/**
 * 服务器地址
 * @description 写url请按照服务划分区块并写好注释
 * @author mll
 * @date 2020-1-2
 */

import * as env from './constants_env'

let environment = env.env_host
let baseUrl = environment + '/base-server/v1.0'
let adminUrl = environment && environment !== '' ? environment + '/admin-server/v1.0' : '/admin' + '/admin-server/v1.0'

let workflowPath = ''//'/workflow/workflow-server/v1.0'; mll 2021-03-27 统一调用后台接口注释
let workflowHttpPath = ''//'http://106.14.34.81:13014/workflow-server/v1.0/'; mll 2021-03-27 统一调用后台接口注释
let faceUrl = '/face/face-server/v1.0'//'/face/face-server/v1.0'  mll 2021-03-27 统一调用后台接口注释

/**
 * 框架级别的modal需要使用的url，使用ossUpload组件时会引用，误删！
 * oss上传
 */
//export const kUrlGetFileUploadParam = adminUrl + '/admin-file/getFileUploadParam' //获取上传参数
export const kUrlGetFileUploadParam = adminUrl + '/admin-file/getFileUploadParamByBucketName' //获取上传参数,支持多bucketName增强版
export const kUrlAddUploadSystemFileInfo = adminUrl + '/admin-file/addUploadSystemFileInfo' //新增待上传系统文件file信息
export const kUrlAddUploadCourseWareFileInfo = adminUrl + '/admin-file/addUploadCourseWareFileInfo' //新增待上传课件file信息
export const kUrlAddUploadTempFileInfo = adminUrl + '/admin-file/addUploadTempFileInfo' //新增待上传临时文件file信息
export const kUrlUploadFileUpdateCmd = adminUrl + '/admin-file/updateFileInfo' //修改上传文件file信息
export const kUrlAddUploadHomeworkFileInfo = adminUrl + '/admin-file/addUploadHomeworkFileInfo' //新增待上传系统文件file信息


export const kUrlGetQueryFileInfoList = adminUrl + '/admin-file/queryFileInfoList' //查询文件信息
export const kUrlGetFileInfoByFileId = adminUrl + '/admin-file/getFileInfoByFileId' //根据fileId获取文件信息
export const kUrlGetFileInfoByIds = adminUrl + '/admin-file/getFileInfoByIds' //根据fileIds获取文件信息

export const kUrlGetPlayList = adminUrl + '/admin-video/getPlaylist' //获取中目视频播放地址


/**
 * 系统菜单
 */
export const kUrlMenu = baseUrl + '/base-roleMenuElements/getMenusAndElementsByPersonId'

export const kUrlVersionListByPage = baseUrl + '/base-version/listByPage'
export const kUrlCreateVersion = baseUrl + '/base-version/createVersion'
export const kUrlUpdateVersion = baseUrl + '/base-version/updateVersion'
export const kUrlFindVersionById = baseUrl + '/base-version/findVersionById'
export const kUrlDeleteVersion = baseUrl + '/base-version/deleteVersion'
//export const kUrlLogin = '/sys/login'

/**
 * 组织结构管理
 */
//人员管理
export const kUrlPersonManage = baseUrl + '/base-personInfo/listByPage' //人员分页信息
//根据配置表的key获取到角色id 根据角色id查询对应的人员
export const kUrlListByConfigPageForAbility = baseUrl + '/base-personInfo/listByConfigPage'
export const kUrlPersonInfoExport = baseUrl + '/base-personInfo/personInfoExport' //人员信息导出
export const kUrlPersonIdentityInfoExport = baseUrl + '/base-personInfo/personIdentityInfoExport' //人员任职信息导出
export const kUrlQueryPersonOrgInfoByPersonId = baseUrl + '/base-personInfo/queryPersonOrgInfoByPersonId';
export const kUrlPersonAndUserIdentitiesInfo = baseUrl + '/base-personInfo/personAndUserIdentitiesInfo' //查看人员信息
export const kUrlPersonAndUserInfo = baseUrl + '/base-personInfo/personAndUserInfo' //查看人员user及personInfo信息
export const kUrlPersonAndUserInfoFilter = baseUrl + '/base-personInfo/listByPage' //查看人员user及personInfo信息,过滤已角色已存在人员
export const kUrlPersonManageEnable = baseUrl + '/base-personInfo/enable' //通过状态更改人员分页信息
export const kUrlPersonManageAdd = baseUrl + '/base-personInfo/add' //新增人员信息
export const kUrlPersonManageUpd = baseUrl + '/base-personInfo/upd' //修改人员信息
export const kUrlPsersonResetPassword = baseUrl + '/base-personInfo/resetPassword' //人员重置密码
export const kUrlPersonBatchChangeState = baseUrl + '/base-personInfo/batchChangeState' //人员批量禁用/启用
export const kUrlPersonAndUserInfoList = baseUrl + '/base-personInfo/personAndUserInfoList'
export const kUrlTeachManage = baseUrl + '/base-personInfo/getTeachelist' //获取讲师列表，根据当前人的任职组织
//导出人员 随机序号
export const kUrlPersonInfoExportRandomNumber = baseUrl + '/base-personInfo/personInfoExportRandomNumber' //人员信息导出
export const kUrlPersonInfoImport = baseUrl + '/base-personInfo/import' //人员信息导入

export const kUrlPersonSelect = baseUrl + '/base-personInfo/personSelect' //人员信息导入
export const kUrlImportSchoolCooperationPerson = baseUrl + '/base-personInfo/importSchoolCooperationPerson' //导入校企合作人员
export const kUrlImportPerson = baseUrl + '/base-personInfo/importPerson' //导入人员


//岗位管理
export const kUrlPositionPageNoFilter = baseUrl + '/base-position/pageNoFilterList';//岗位列表  获取全部岗位 没有权限过滤
export const kUrlPositionPage = baseUrl + '/base-position/pageList';//岗位列表
export const kUrlPositionAdd = baseUrl + '/base-position/add';//新增岗位
export const kUrlPositionUpdate = baseUrl + '/base-position/update';//修改岗位
export const kUrlPositionUpdateState = baseUrl + '/base-position/updateState';//修改岗位状态
export const kUrlPositionBatchDelete = baseUrl + '/base-position/batchDelete';//删除岗位
export const kUrlPositionExport = baseUrl + '/base-position/export';//岗位信息导出
export const kUrlPositionInfo = baseUrl + '/base-position/getById';//岗位列表  获取全部岗位 没有权限过滤

//岗位分类管理
export const kUrlPositionCategoryList = baseUrl + '/base-positionCategory/list';//岗位分类列表
export const kUrlPositionCategoryPage = baseUrl + '/base-positionCategory/pageList';//岗位分类分页列表
export const kUrlPositionCategoryAdd = baseUrl + '/base-positionCategory/add';//新增岗位分类
export const kUrlPositionCategoryUpdate = baseUrl + '/base-positionCategory/update';//修改岗位分类
export const kUrlPositionCategoryBatchDelete = baseUrl + '/base-positionCategory/batchDelete';//删除岗位分类
//组织分类管理
export const kUrlTypeNodeList = baseUrl + '/base-organizationNodeCategory/typeNodeList'  //树结构 get
export const kUrlListByPage = baseUrl + '/base-organizationNodeCategory/listByPage'  //组织类型信息  post
export const kUrlGetParentNameList = baseUrl + '/base-organizationNodeCategory/getParentNameList'  //父组织类型名称 get
export const kUrlOperate = baseUrl + '/base-organizationNodeCategory'  //操作组织信息
export const kUrlOrganizationNodeCategoryAdd = baseUrl + '/base-organizationNodeCategory/add'//新增组织分类
export const kUrlOrganizationNodeCategoryUpdate = baseUrl + '/base-organizationNodeCategory/upd'//修改组织分类
export const kUrlOrganizationNodeCategoryDelete = baseUrl + '/base-organizationNodeCategory/del'//删除组织分类
export const kUrlOrganizationNodeCategoryEnable = baseUrl + '/base-organizationNodeCategory/enable'//启用/禁用组织分类
export const kUrlOrganizationExport = baseUrl + '/base-organization/export' //组织导出查询
//组织管理
export const kUrlOrganizationListByNoFilterPage = baseUrl + '/base-organization/listByNoFilterPage' //组织分页查询 获取全部组织 不经过权限过滤
export const kUrlOrganizationListByPage = baseUrl + '/base-organization/listByPage' //组织分页查询
export const kUrlOrganizationTreeData = baseUrl + '/base-organization/nodeList' //组织树查询
export const kUrlAddOrganization = baseUrl + '/base-organization/add' //新增组织
export const kUrlUpdateOrganization = baseUrl + '/base-organization/upd' //修改组织
export const kUrlDeleteOrganization = baseUrl + '/base-organization/del' //删除组织
export const kUrlgetOrganizationInfo = baseUrl + '/base-organization/getOrganizationInfo' //根据id获取组织信息
export const kUrlEnableOrganization = baseUrl + '/base-organization/enable' //启用/禁用组织
export const kUrlGetOrgAuthorityInfo = baseUrl + '/base-organizationManager/listByPage' //组织权限管理分页查询
export const kUrlEnableOrgAuthority = baseUrl + '/base-organizationManager/enable' //启用/禁用组织权限
export const kUrlDeleteOrgAuthority = baseUrl + '/base-organizationManager/del' //启用/禁用组织权限
export const kUrlCreateOrgAuthority = baseUrl + '/base-organizationManager/add' //新增组织权限
export const kUrlOrganizationPageListByCond = baseUrl + '/base-organization/pageListByCond' //组织分页查询 组织类型查询不包含下级类型
export const kUrlImportOrganization = baseUrl + '/base-organization/import' //导入成绩
export const kUrlOrganizationByUser = baseUrl + '/base-organization/getOrganizationPageByUser'//获取当前登录人可管理的组织
export const kUrlOrgSelect = baseUrl + '/base-organization/orgSelect' //导入文档查询组织
export const kUrlOrganizationZoneCodePage = adminUrl + '/admin-organizationZoneCode/getListByPage' //zoneCode列表分页查询
export const kUrlOrganizationZoneCodeAdd = adminUrl + '/admin-organizationZoneCode/add'  //新增zoneCode关系
export const kUrlOrganizationZoneCodeUpdate = adminUrl + '/admin-organizationZoneCode/update'  //编辑zoneCode关系
export const kUrlOrganizationZoneCodeDelete = adminUrl + '/admin-organizationZoneCode/delete'  //删除zoneCode关系
export const kUrlOrganizationZoneCodeExport = adminUrl + '/admin-organizationZoneCode/getList'  //导出zoneCode关系
export const kUrlOrganizationZoneCodeEnable = adminUrl + '/admin-organizationZoneCode/changeState'  //启、禁用zoneCode关系


//经销商管理
export const kUrlDealerPage = baseUrl + '/base-dealer/pageList';//经销商分页列表
export const kUrlDealerAdd = baseUrl + '/base-dealer/add';//新增经销商
export const kUrlDealerUpdate = baseUrl + '/base-dealer/update';//修改经销商
export const kUrlDealerBatchDelete = baseUrl + '/base-dealer/batchDelete';//删除经销商
export const kUrlDealerExport = baseUrl + '/base-dealer/export';//导出经销商
export const kUrlDealerLook = baseUrl + '/base-dealer/look';//查看经销商
//共建店管理
export const kUrlDealerUnionPage = baseUrl + '/base-dealerUnion/pageList';//共建店分页列表
export const kUrlDealerUnionImport = baseUrl + '/base-dealerUnion/import';//共建店信息导入
export const kUrlDealerUnionExport = baseUrl + '/base-dealerUnion/export';//共建店信息导出
export const kUrlDealerUnionUpdateState = baseUrl + '/base-dealerUnion/updateState';//共建店信息状态更改

/**
 * 系统管理
 * */
//菜单管理
export const kUrlGetMenus = baseUrl + '/base-menu/getMenus'  //树结构 get
export const kUrlMenuListByPage = baseUrl + '/base-menu/listByPage'  //菜单列表 get
export const kUrlChangeMenuDisable = baseUrl + '/base-menu/changeDisable'  //菜单启用禁用 put
export const kUrlGetMenusForTpye = baseUrl + '/base-menu/getMenusForTpye'  //根据类型获取菜单 get
export const kUrlAddMenu = baseUrl + '/base-menu/addMenu'  //创建菜单 post
export const kUrlUpdateMenu = baseUrl + '/base-menu/updateMenu'  //修改菜单 put
export const kUrlGetExportMenus = baseUrl + '/base-menu/getExportMenus'  //导出
//元素管理
export const kUrlElementsListByPage = baseUrl + '/base-elements/listByPage'  //元素列表分页查询
export const kUrlAddElements = baseUrl + '/base-elements/addElements'  //新增元素
export const kUrlDeleteElements = baseUrl + '/base-elements/deleteElements'  //删除元素
export const kUrlUpdateElements = baseUrl + '/base-elements/updateElements'  //修改元素
export const kUrlSetElements = baseUrl + '/base-elements/setElements'  //启用、禁用
export const kUrlListByCondition = baseUrl + '/base-elements/listByCondition'  //根据条件获取元素 get
export const kUrlGetElementsByMenuId = baseUrl + '/base-elements/getElementsByMenuId'  //根据菜单id获取元素 get
export const kUrlExportElements = baseUrl + '/base-elements/exportElements'  //导出
//用户组管理
export const kUrlGroupListByPage = baseUrl + '/base-group/queryGroupPage'  //用户组分页列表
export const kUrlQueryGroupList = baseUrl + '/base-group/queryGroupList'  //用户组列表
export const kUrlGroupListByPageFilter = baseUrl + '/base-group/queryGroupPageFilter'  //用户组分页列表,过滤已添加用户组
export const kUrlAddGroup = baseUrl + '/base-group/addGroup'  //新增用户组信息
export const kUrlUpdateGroup = baseUrl + '/base-group/updateGroup'  //修改用户组信息
export const kUrlDeleteGroup = baseUrl + '/base-group/deleteGroup'  //删除用户组信息
export const kUrlUpdateGroupState = baseUrl + '/base-group/updateGroupState'  //修改用户组状态
//用户与用户组管理
export const kUrlGroupUserListByPage = baseUrl + '/base-groupUser/queryGroupUserPage'  //用户与用户组关联关系分页列表
export const kUrlAddGroupUser = baseUrl + '/base-groupUser/addGroupUser'  //新增用户与用户组关联关系信息
export const kUrlAddGroupUserByUser = baseUrl + '/base-groupUser/addGroupUserByUser'  //根据用户新增用户与用户组关联关系信息
export const kUrlDeleteGroupUser = baseUrl + '/base-groupUser/deleteGroupUser'  //删除用户与用户组关联关系信息
export const kUrlQueryGroupUserList = baseUrl + '/base-groupUser/queryGroupUserList'  //查询用户与用户组关联关系信息

//用户账号管理
export const kUrlUserListByPage = baseUrl + '/base-user/userListByPage'  //用户账号分页列表
export const kUrlAddUser = baseUrl + '/base-user/addUser'  //新增用户账户信息
export const kUrlUpdateUser = baseUrl + '/base-user/updateUser'  //修改用户账户信息
export const kUrlDeleteUser = baseUrl + '/base-user/deleteUser'  //删除用户账户信息
export const kUrlUpdateUserDisabled = baseUrl + '/base-user/updateUserDisabled'  //修改用户账户状态
export const kUrlUpdateUserResetPassword = baseUrl + '/base-user/userResetPassword'  //用户账户重置密码
export const kUrlUserListByGroupPlugPage = baseUrl + '/base-user/userListByGroupPlugPage'  //用户组选择人员插件url

//角色管理
export const kUrlRoleListByPage = baseUrl + '/base-role/listByPage'  //角色列表 get
export const kUrlAddRole = baseUrl + '/base-role/add'  //角色新增
export const kUrlDeleteRole = baseUrl + '/base-role/delete'  //角色删除
export const kUrlUpdateRole = baseUrl + '/base-role/update'  //角色更新
export const kUrlRoleListByCondition = baseUrl + '/base-role/listByCondition' //条件查询不分页
export const kUrlExportRoles = baseUrl + '/base-role/exportRoles'  //导出

//角色用户管理
export const kUrlRoleUserListByPage = baseUrl + '/base-roleUser/listByPage'  //角色用户列表
export const kUrlAddRoleUser = baseUrl + '/base-roleUser/add'  //角色用户新增
export const kUrlDeleteRoleUser = baseUrl + '/base-roleUser/delete'  //角色用户删除
export const kUrlUpdateRoleUser = baseUrl + '/base-roleUser/update'  //角色用户更新
export const kUrlRoleUserListByCondition = baseUrl + '/base-roleUser/listByCondition'  //角色用户更新
export const kUrlUpdateOrSaveRoleUser = baseUrl + '/base-roleUser/updateOrSave'  //角色用户修改或新增
export const kUrlAddUsersForRoleRoleUser = baseUrl + '/base-roleUser/addUsersForRole'  //根据角色,personId批量新增用户关联关系
export const kUrlAddUsersForRoleByUserNameRoleUser = baseUrl + '/base-roleUser/addUsersForRoleByUserName'  //根据角色,账号批量新增用户关联关系
export const kUrlGetPersonIdsByRoleIds = baseUrl + '/base-roleUser/getPersonIdsByRoleIds' //通过角色id 获取用户数量
export const kUrlImportRoleUser = baseUrl + '/base-roleUser/import' //导入

//角色用户组管理
export const kUrlRoleGroupListByPage = baseUrl + '/base-roleGroup/listByPage'  //角色用户列表
export const kUrlAddRoleGroup = baseUrl + '/base-roleGroup/add'  //角色用户新增
export const kUrlDeleteRoleGroup = baseUrl + '/base-roleGroup/delete'  //角色用户删除
export const kUrlUpdateRoleGroup = baseUrl + '/base-roleGroup/update'  //角色用户更新
export const kUrlRoleGroupListByCondition = baseUrl + '/base-roleGroup/listByCondition'  //角色用户更新
export const kUrlUpdateOrSaveRoleGroup = baseUrl + '/base-roleGroup/updateOrSave'  //角色用户修改或新增
export const kUrlAddGroupsForRoleRoleGroup = baseUrl + '/base-roleGroup/addGroupsForRole'  //根据角色批量新增用户关联关系

//角色与菜单与元素关联
export const kUrlAddRoleMenuElements = baseUrl + '/base-roleMenuElements/batchSave'  //创建角色菜单中间表 post
export const kUrlGetMenuRightOfUse = baseUrl + '/base-roleMenuElements/getMenuRightOfUse'  //通过菜单id获取所有角色权限及元素操作 get
export const kUrlGetMenuPowerByRoleId = baseUrl + '/base-roleMenuElements/getMenuPowerByRoleId'  //通过菜单id获取所有角色权限及元素操作 get

//接口
export const kUrlApiInfoListByPage = baseUrl + '/base-apiInfo/listByPage'  //接口列表分页查询
export const kUrlAddApiInfo = baseUrl + '/base-apiInfo/addApiInfo'  //新增接口
export const kUrlDeleteApiInfo = baseUrl + '/base-apiInfo/deleteApiInfos'  //删除接口
export const kUrlUpdateApiInfo = baseUrl + '/base-apiInfo/updateApiInfo'  //修改接口信息
export const kUrlupdateApiInfoByState = baseUrl + '/base-apiInfo/updateApiInfoByState'  //修改接口信息

//接口角色关联
export const kUrlGetRoleApiListByQry = baseUrl + '/base-roleApi/getRoleApiListByQry'  //获取接口与角色关系数据
export const kUrlAddRoleApiMany = baseUrl + '/base-roleApi/addRoleApiMany'  //接口分配角色接口

//角色组管理
export const kUrlRoleSetsListByCondition = baseUrl + '/base-roleSets/listByPage' //条件查询 get
export const kUrlAddRoleSet = baseUrl + '/base-roleSets/addRoleSet' //新增角色组 post
export const kUrlUpdateRoleSet = baseUrl + '/base-roleSets/updateRoleSet' //编辑角色组 put
export const kUrlDeleteRoleSet = baseUrl + '/base-roleSets/deleteRoleSet' //删除角色组 del

export const kUrlAddRoleSetsRole = baseUrl + '/base-roleSetsRole/addRoleSetsRole' //批量保存角色组角色 put
export const kUrlRoleSetsRoleList = baseUrl + '/base-roleSetsRole/listByCondition' //获取已选角色 get

export const kUrlRoleManagementBatchSave = baseUrl + '/base-roleManagementRoleSets/batchSave' //批量保存可控角色组的角色 del
export const kUrlRoleManagementList = baseUrl + '/base-roleManagementRoleSets/list' //获取已选角色 get


//获取任职信息接口
export const kUrlQueryUserIdentityDetailPage = baseUrl + '/base-userIdentity/queryUserIdentityDetailPage' //获取任职详细信息接口
export const kUrlQueryUserIdentityInfoList = baseUrl + '/base-userIdentity/queryUserIdentityInfoList' //查询用户身份

/**
 * 在线课程管理
 */
//课程管理
export const kUrlProgramListByPage = adminUrl + '/admin-program/listByPage' //条件查询 get
export const kUrlAddProgram = adminUrl + '/admin-program/add' //新增基础信息
export const kUrlUpdateProgram = adminUrl + '/admin-program/update' //编辑基础信息
export const kUrlUpdateProgramStatus = adminUrl + '/admin-program/updateProgramStatus' //发布or关闭
export const kUrlExportProgram = adminUrl + '/admin-program/list' //导出课程详情
export const kUrlDeleteProgram = adminUrl + '/admin-program/delete' //删除课程

//课程内容
export const kUrlAddProgramEntity = adminUrl + '/admin-programEntity/addProgramEntityList' //保存课程内容addProgramEntityList
export const kUrlGetProgramEntity = adminUrl + '/admin-programEntity/getListByProgramId' //获取课程内容

export const kUrlProgramAuthInfo = adminUrl + '/admin-program/authInfo' //获取权限信息
export const kUrlProgramSaveAuth = adminUrl + '/admin-program/saveAuth' //保存权限信息
export const kUrlGetProgramById = adminUrl + '/admin-program/getProgramById' //获取

//课件管理
export const kUrlScheduleListByPage = adminUrl + '/admin-schedule/querySchedulePage' //条件查询 get
export const kUrlAddSchedule = adminUrl + '/admin-schedule/addSchedule' //新增
export const kUrlUpdateSchedule = adminUrl + '/admin-schedule/updateSchedule' //编辑
export const kUrlUpdateScheduleStatus = adminUrl + '/admin-schedule/updateScheduleStatus' //修改状态
export const kUrlDeleteSchedule = adminUrl + '/admin-schedule/deleteSchedule' //删除课件
export const kUrlExportSchedule = adminUrl + '/admin-schedule/exportScheduleList' //导出

//登录相关
export const kUrlLogin = baseUrl + '/base-user/login' //登录
export const kUrlLogout = baseUrl + '/base-user/logout' //登出
export const kUrlImageCaptcha = baseUrl + '/base-user/getImageCaptcha' //获取图片验证码
export const kUrlCaptchaCode = baseUrl + '/base-user/getVerificationCode' // 获取验证码字符串


/**
 * 在线考核
 */

// 主观题批阅
export const kUrlExamManualReviewPage = adminUrl + '/admin-examManualReview/listByPage'
export const kUrlExamManualReviewExport = adminUrl + '/admin-examManualReview/list'

// 主观题批阅-学员考试记录
export const kUrlExamPaperReviewPage = adminUrl + '/admin-examPaperReview/listByPage'
export const kUrlExamPaperReviewExport = adminUrl + '/admin-examPaperReview/list'
export const kUrlExamPaperReviewInfo = adminUrl + '/admin-examPaperReview/reviewInfo' // 批阅展示
export const kUrlExamPaperReviewLook = adminUrl + '/admin-examPaperReview/look' // 查看
export const kUrlExamPaperReviewConfirmReview = adminUrl + '/admin-examPaperReview/confirmReview' // 批阅返回,批阅并继续

// 考试记录管理
export const kUrlExamRecordPage = adminUrl + '/admin-examRecord/pageList';
export const kUrlExamGradePage = adminUrl + '/admin-examRecord/gradePageList';
export const kUrlExamInfoPage = adminUrl + '/admin-examRecord/infoPageList';
export const kUrlExamRecordExport = adminUrl + '/admin-examRecord/export';
export const kUrlExamRecordInfoExport = adminUrl + '/admin-examRecord/infoExport';
export const kUrlExamGradeInfoExportByPosition = adminUrl + '/admin-examRecord/gradeExportByPosition';
export const kUrlExamGradeInfoExportByPositionInfo = adminUrl + '/admin-examRecord/gradeExportByPositionInfo';
export const kUrlExamRecordInfoCharts = adminUrl + '/admin-examRecord/infoCharts';
export const kUrlExamGradeInfoCharts = adminUrl + '/admin-examRecord/gradeCharts';
export const kUrlExamStudentAnswerDetail = adminUrl + '/admin-examRecord/exportByStudentAnswerDetail';
export const KUrlExamQuestionAnswerDetail = adminUrl + '/admin-examRecord/exportByQuestionAnswerDetail';
export const kUrlReviewedPaper = adminUrl + '/admin-examRecord/reviewedPaper';

//考试错题率分析
export const kUrlErrorQuetionPage = adminUrl + '/admin-examRecord/getErrorQuetionPage'; //错题率详情
export const kUrlErrorQuestionAnswerPage = adminUrl + '/admin-examRecord/getErrorQuestionAnswerPage'; //错题答案分析
export const kUrlErrorQuestionPersonInfoPage = adminUrl + '/admin-examRecord/getErrorQuestionPersonInfoPage'; //错误人员情况
export const KUrlErrorQuestionPersonInfoAnalysisPage = adminUrl + '/admin-examRecord/getErrorQuestionPersonInfoAnalysisPage'; //错误人员分析

export const kUrlErrorQuetionExport = adminUrl + '/admin-examRecord/getErrorQuetionList'; //错题率详情
export const kUrlErrorQuestionAnswerExport = adminUrl + '/admin-examRecord/getErrorQuestionAnswerList'; //错题答案分析
export const kUrlErrorQuestionPersonInfoExport = adminUrl + '/admin-examRecord/getErrorQuestionPersonInfoList'; //错误人员情况
export const KUrlErrorQuestionPersonInfoAnalysisExport = adminUrl + '/admin-examRecord/getErrorQuestionPersonInfoAnalysisList'; //错误人员分析


//考试
export const kUrlExamExport = adminUrl + '/admin-exam/export';
export const kUrlCreateExam = adminUrl + '/admin-exam/createExam';
export const kUrlUpdateExam = adminUrl + '/admin-exam/updateExam';
export const kUrlExamListByPage = adminUrl + '/admin-exam/listByPage';
export const kUrlAddExamChapter = adminUrl + '/admin-exam/saveExamChapter';
export const kUrlExamChapterInfo = adminUrl + '/admin-exam/examChapterInfo';
export const kUrlExamPreviewInfo = adminUrl + '/admin-exam/examPreviewInfo';
export const kUrlExamLookPreviewInfo = adminUrl + '/admin-exam/lookPreviewInfo';
export const kUrlChapterPreviewInfo = adminUrl + '/admin-exam/chapterPreviewInfo';
export const kUrlExamAuthInfo = adminUrl + '/admin-exam/authInfo';
export const kUrlExamTargetScopeInfo = adminUrl + '/admin-exam/targetScopeInfo';
export const kUrlExamSaveAuth = adminUrl + '/admin-exam/saveAuth';
export const kUrlExamPublish = adminUrl + '/admin-exam/publish';
export const kUrlExamClose = adminUrl + '/admin-exam/close';
export const kUrlExamQuestionImport = adminUrl + '/admin-exam/importExamQuestion';
export const kUrlExamInfoById = adminUrl + '/admin-exam/getExamById';
export const kUrlDelExam = adminUrl + '/admin-exam/delExam';
export const kUrlFullMarkPaper = adminUrl + '/admin-examPaper/fullMarkPaper';
export const kUrlDelPaper = adminUrl + '/admin-examPaper/delPaper'
export const kUrlChangeExamFaceAuth = adminUrl + '/admin-exam/changeExamFaceAuth';
//考试模版
export const kUrlExamTemplateListByPage = adminUrl + '/admin-examTemplate/listByPage'
export const kUrlExamTemplateEnable = adminUrl + '/admin-examTemplate/enable'
export const kUrlExamTemplateLookPreviewInfo = adminUrl + '/admin-examTemplate/lookPreviewInfo'
export const kUrlCreateExamTemplate = adminUrl + '/admin-examTemplate/createExamTemplate'
export const kUrlUpdateExamTemplate = adminUrl + '/admin-examTemplate/updateExamTemplate'
export const kUrlExamTemplateChapterInfo = adminUrl + '/admin-examTemplate/examTemplateChapterInfo'
export const kUrlSaveExamTemplateChapter = adminUrl + '/admin-examTemplate/saveExamTemplateChapter'
export const kUrlExamTemplateBatchDelete = adminUrl + '/admin-examTemplate/batchDelete'
export const kUrlExamTemplateExport = adminUrl + '/admin-examTemplate/export'
export const kUrlExamTemplateById = adminUrl + '/admin-examTemplate/getExamTemplateById';

//考试模版组
export const kUrlExamTemplateGroupListByPage = adminUrl + '/admin-examTemplateGroup/pageList'
export const kUrlExamTemplateGroupExport = adminUrl + '/admin-examTemplateGroup/export'
export const kUrlExamTemplateGroupEnable = adminUrl + '/admin-examTemplateGroup/enable'
export const kUrlExamTemplateGroupAdd = adminUrl + '/admin-examTemplateGroup/add'
export const kUrlExamTemplateGroupUpdate = adminUrl + '/admin-examTemplateGroup/update'
export const kUrlExamTemplateGroupBatchDelete = adminUrl + '/admin-examTemplateGroup/batchDelete'
export const kUrlExamTemplateGroupAuthInfo = adminUrl + '/admin-examTemplateGroup/authInfo'
export const kUrlExamTemplateGroupSaveAuth = adminUrl + '/admin-examTemplateGroup/saveAuth'
export const kUrlExamTemplateGroupById = adminUrl + '/admin-examTemplateGroup/getExamTemplateGroupById'
export const kUrlExamTemplateRelationListByCondition = adminUrl + '/admin-examTemplateRelation/listByPage'
export const kUrlExamTemplateRelationAdd = adminUrl + '/admin-examTemplateRelation/add'
export const kUrlExamTemplateRelationUpdate = adminUrl + '/admin-examTemplateRelation/update'
export const kUrlExamTemplateRelationEnable = adminUrl + '/admin-examTemplateRelation/changeStatus'

//题库题目
export const kUrlAddBankQuestion = adminUrl + '/admin-questionBank/add';//添加题库题目
export const kUrlUpdBankQuestion = adminUrl + '/admin-questionBank/upd';//修改题库题目
export const kUrlDelBankQuestion = adminUrl + '/admin-questionBank/del';//删除题库题目
export const kUrlBankQuestionListByPage = adminUrl + '/admin-questionBank/listByPage';//获取分页对象
export const kUrlBankQuestionUserListByPage = adminUrl + '/admin-questionBank/userListByPage';//获取分页对象
export const kUrlBankQuestionNormalListByPage = adminUrl + '/admin-questionBank/normalListByPage';//获取分页对象
export const kUrlBankQueryCount = adminUrl + '/admin-questionBank/queryCount';//获取题目数
export const kUrlBankQuestionInfo = adminUrl + '/admin-questionBank/bankQuestionInfo';//获取修改题库题目信息
export const kUrlBankQuestionImport = adminUrl + '/admin-questionBank/import';//题目导入
export const kUrlBankQuestionExport = adminUrl + '/admin-questionBank/export';//题目导出


//分类管理接口
export const kUrlAddCategoryInfo = adminUrl + '/admin-categoryInfo/add' //添加分类
export const kUrlUpdCategoryInfo = adminUrl + '/admin-categoryInfo/upd' //修改分类
export const kUrlDelCategoryInfo = adminUrl + '/admin-categoryInfo/del' //删除分类
export const kUrlEnableCategoryInfo = adminUrl + '/admin-categoryInfo/enable' //启用禁用
export const kUrlCategoryInfoListByPage = adminUrl + '/admin-categoryInfo/listByPage' //获取page对象
export const kUrlCategoryNormalInfoListByPage = adminUrl + '/admin-categoryInfo/normalListByPage' //获取普通管理page对象
export const kUrlExportCategoryInfo = adminUrl + '/admin-categoryInfo/export' //分类导出
export const kUrlImportCategoryInfo = adminUrl + '/admin-categoryInfo/import'; //分类导入
export const kUrlCategoryInfoNodeList = adminUrl + '/admin-categoryInfo/nodeList' //获取ListTree对象
export const kUrlCategoryInfoNormalNodeList = adminUrl + '/admin-categoryInfo/normalNodeList' //获取权限关联ListTree对象
export const kUrlCategoryInfoUserNodeList = adminUrl + '/admin-categoryInfo/userNodeList' //获取权限关联ListTree对象
export const kUrlCategoryInfoList = adminUrl + '/admin-categoryInfo/queryList' //获取List对象
export const kUrlCategoryAuthInfo = adminUrl + '/admin-categoryInfo/authInfo';
export const kUrlCategorySaveAuth = adminUrl + '/admin-categoryInfo/saveAuth';
export const kUrlCategoryInfoListByPageNew = adminUrl + '/admin-categoryInfo/listByPageNew' //获取page对象,过滤自身
/**
 * 互动直播管理
 */
export const kUrlLiveListByPage = adminUrl + '/admin-live/listByPage';//列表查询
export const kUrlSetLiveStatus = adminUrl + '/admin-live/setLiveStatus';//修改直播状态
export const kUrlAddLive = adminUrl + '/admin-live/addLive';//新增直播
export const kUrlUpdateLive = adminUrl + '/admin-live/updateLive';//修改直播
export const kUrlGetLiveList = adminUrl + '/admin-live/listByCondition';//条件查询，导出
export const kUrlLiveAuthInfo = adminUrl + '/admin-live/authInfo';
export const kUrlLiveSaveAuth = adminUrl + '/admin-live/saveAuth';

/**互动直播 */
export const kUrlInteractListByPage = adminUrl + '/admin-interactLive/getPageList';//列表查询
export const kUrlAdd = adminUrl + '/admin-interactLive/add';//新增直播
export const kUrlUpdate = adminUrl + '/admin-interactLive/upd';//修改直播
export const kUrlAddInteractLive = adminUrl + '/admin-interactLive/addInteractLive';//新增直播
export const kUrlUpdateInteractLive = adminUrl + '/admin-interactLive/updateInteractLive';//修改直播
export const kUrlSelectInteractLiveDetailInfo = adminUrl + '/admin-interactLive/selectInteractLiveDetailInfoById';//获取直播信息
export const kUrlDeleteInteractLive = adminUrl + '/admin-interactLive/delete';//删除直播
export const kUrlGetInteractLiveInfo = adminUrl + '/admin-interactLive/getInfoById';//获取直播信息
export const kUrlSetInteractLiveState = adminUrl + '/admin-interactLive/setInteractLiveState';//获取直播信息
export const kUrlExportLiveAuthInfo = adminUrl + '/admin-interactLive/exportAuthInfo';//导出受众
export const kUrlExportLive = adminUrl + '/admin-interactLive/export';//直播列表导出
export const kUrlGetLiveRoomInfo = adminUrl + '/admin-interactLive/getLiveRoomInfoById';//
export const kUrlGetInteractLiveRecordVideo = adminUrl + '/admin-interactLive/getInteractLiveRecordVideoByOwnerId';//获取录制记录列表
export const kUrlCheckMeetingDate = adminUrl + '/admin-interactLive/checkMeetingDate';//校验对应时间段是否有直播资源
export const kUrlGetInteractLiveTimes = adminUrl + '/admin-interactLive/getInteractLiveTimes';//直接获取第三方直播场次记录
export const kUrlExportInteractLiveRecordDetail = adminUrl + '/admin-interactLive/exportInteractLiveRecordDetail';//直接获取第三方直播参训记录明细

/**
 * 直播资源管理
 */
export const kUrlInteractLiveResourcesByPage = adminUrl + '/admin-interactLiveResources/getPageList';//列表查询
export const kUrlInteractLiveResourcesByList = adminUrl + '/admin-interactLiveResources/getList';//导出查询
export const kUrlInteractLiveResourcesById = adminUrl + '/admin-interactLiveResources/selectInteractLiveResourcesById';//单个查询

export const kUrlBatchCreateZoomUserResources = adminUrl + '/admin-interactLiveResources/batchCreateZoomUserResources';//批量创建账号
export const kUrlBatchSyncUserResourcesUserType = adminUrl + '/admin-interactLiveResources/batchSyncUserResourcesUserType';//同步批量同步资源账号用户付费类型
export const kUrlInteractLiveResourcesUpdateState = adminUrl + '/admin-interactLiveResources/updateResourcesState';//修改资源帐户状态

/**正常经销商管理 */
export const kUrlNormalDealerListByPage = adminUrl + '/admin-normalDealer/getPageList';//列表查询
export const kUrlAddNormalDealer = adminUrl + '/admin-normalDealer/add';//新增直播
export const kUrlDeleteNormalDealer = adminUrl + '/admin-normalDealer/delete';//删除直播
export const kUrlImportNormalDealer = adminUrl + '/admin-normalDealer/importFile';//导入直播
export const kUrlExportNormalDealer = adminUrl + '/admin-normalDealer/export';//导出直播


//互动直播  参训记录
export const kUrlLiveRecordGetPageList = adminUrl + '/admin-interactLiveRecord/getPageList';
export const kUrlLiveRecordExport = adminUrl + '/admin-interactLiveRecord/export';
export const kUrlLiveRecordSyncRecord = adminUrl + '/admin-interactLiveRecord/syncRecord';

//互动直播  参训统计管理
export const kUrlLiveStatisticsListByPage = adminUrl + '/admin-statisticsRule/getPageList';
export const kUrlAddLiveStatistics = adminUrl + '/admin-statisticsRule/add';
export const kUrlUpdLiveStatistics = adminUrl + '/admin-statisticsRule/upd';
export const kUrlDeleteLiveStatistics = adminUrl + '/admin-statisticsRule/delete';
export const kUrlSyncCalculationTrainReport = adminUrl + '/admin-statisticsRule/syncCalculationTrainReport';
export const kUrlStatisticsRuleSelectOneById = adminUrl + '/admin-statisticsRule/selectOneById';
export const kUrlSyncRecord = adminUrl + '/admin-trainReportRecord/syncRecord';


//互动直播 主持人管理
export const kUrlInteractHostListByPage = adminUrl + '/admin-interactLive/getHostPageList';//主持人列表查询
export const kUrlGetWebLiveUrl = adminUrl + '/admin-interactLive/getWebLiveUrl';//主持人列表查询
export const kUrlGetWebUploadBackPlayUrl = adminUrl + '/admin-interactLive/getWebUploadBackPlay';
//签到
export const kUrlAddSign = adminUrl + '/admin-sign/addSign';//添加
export const kUrlUpdateSign = adminUrl + '/admin-sign/updateSign';//修改
export const kUrlDeleteSign = adminUrl + '/admin-sign/deleteSign';//删除
export const kUrlSignListByCondition = adminUrl + '/admin-sign/listByCondition';//列表查询
export const kUrlSetSignStatus = adminUrl + '/admin-sign/setSignStatus';//修改状态
export const kUrlGetSignDetailById = adminUrl + '/admin-sign/getSignDetailById';

export const kUrlSetStudentSignStatus = adminUrl + '/admin-studentSign/setStudentSignStatus';//修改签到状态
export const kUrlSetStudentSignStatusByBatch = adminUrl + '/admin-studentSign/setStudentSignStatusByBatch';//批量修改签到状态
export const kUrlStudentSignListByPage = adminUrl + '/admin-studentSign/listByPage';//列表查询
export const kUrlGetSignList = adminUrl + '/admin-studentSign/listByCondition';//条件查询


//线下培训课程管理
export const kUrlOfflineProgramListByPage = adminUrl + '/admin-offlineProgram/queryOfflineProgramPage'; //条件查询线下培训课程 get
export const kUrlAddOfflineProgram = adminUrl + '/admin-offlineProgram/addOfflineProgram'; //新增线下培训课程
export const kUrlUpdateOfflineProgram = adminUrl + '/admin-offlineProgram/updateOfflineProgram'; //编辑线下培训课程
export const kUrlGetOfflineProgram = adminUrl + '/admin-offlineProgram/getOfflineProgramById'; //获取单个线下培训课程信息
export const kUrlUpdateOfflineProgramStatus = adminUrl + '/admin-offlineProgram/updateOfflineProgramStatus'; //修改线下培训课程状态
export const kUrlDeleteOfflineProgram = adminUrl + '/admin-offlineProgram/deleteOfflineProgram'; //删除线下培训课程
export const kUrlExportOfflineProgram = adminUrl + '/admin-offlineProgram/queryOfflineProgramList'; //导出线下培训课程

//线下培训班级管理


export const kUrlGetClassAideRemoteAuthInfo = adminUrl + '/admin-classInfo/getClassAideRemoteAuthInfo'; //条件查询班级下远程认证环节信息
export const kUrlClassListByCondPage = adminUrl + '/admin-classInfo/listByCondPage'; //条件查询线下培训班级 get
export const kUrlClassListByPage = adminUrl + '/admin-classInfo/listByPage'; //条件查询线下培训班级 get
export const kUrlAddClass = adminUrl + '/admin-classInfo/add'; //新增线下培训班级
export const kUrlUpdateClass = adminUrl + '/admin-classInfo/update'; //编辑线下培训班级
export const kUrlUpdateClassStatus = adminUrl + '/admin-classInfo/updateClassInfoStatus'; //修改线下培训班级状态
export const kUrlDeleteClass = adminUrl + '/admin-classInfo/delete'; //删除线下培训班级
export const kUrlExportClass = adminUrl + '/admin-classInfo/export'; //导出线下培训班级
export const kUrlExportLabels = adminUrl + '/admin-classInfo/exportLabels'; //导出线下培训班级门贴
export const kUrlGetClassById = adminUrl + '/admin-classInfo/getClassById'; //查看线下培训班级
export const kUrlCreateClassTeam = adminUrl + '/admin-classInfo/createClassTeam'; // 创建班级群聊
export const kUrlRemoveClassTeam = adminUrl + '/admin-classInfo/removeClassTeam'; // 删除班级群聊
export const kUrlSyncClassTeam = adminUrl + '/admin-classInfo/syncClassTeam'; // 删除班级群聊

//线下培训班级成绩管理
export const kUrlClassResultByPage = adminUrl + '/admin-classResult/listByPage'; //获取班级成绩分页列表
export const kUrlClassResultInfo = adminUrl + '/admin-classResult/getClassResultInfoByClassId'; //获取班级成绩统计信息
export const kUrlAddClassResult = adminUrl + '/admin-classResult/addClassResult'; //新增成绩
export const kUrlUpdateClassResult = adminUrl + '/admin-classResult/updateClassResult'; //更新成绩
export const kUrlDeleteClassResult = adminUrl + '/admin-classResult/deleteClassResult'; //删除成绩
export const kUrlExportClassResult = adminUrl + '/admin-classResult/listByCondition'; //导出成绩
export const kUrlBatchUpdateClassResult = adminUrl + '/admin-classResult/updatePersonListResult'; //批量修改成绩
export const kUrlImportClassResult = adminUrl + '/admin-classResult/import'; //导入成绩
export const kUrlImportClassResultApply = adminUrl + '/admin-classResult/importFileForApply'; //计划安排管理--导入学员成绩

//kUrlImportClassResult
//线下培训班级助手
export const kUrlClassAideListByPage = adminUrl + '/admin-classAide/queryClassAidePage'; //条件分页查询助手 get
export const kUrlClassAideList = adminUrl + '/admin-classAide/queryClassAideList'; //条件查询助手 get
export const kUrlGetAllClassAideInfoByClassId = adminUrl + '/admin-classAide/getAllClassAideInfoByClassId'; //根据班级ID获取班级所有流程信息
export const kUrlAddClassAide = adminUrl + '/admin-classAide/addClassAide'; //新增助手
export const kUrlUpdateClassAide = adminUrl + '/admin-classAide/updateClassAide'; //编辑助手
export const kUrlSaveOrUpdateEntityInfo = adminUrl + '/admin-classAide/saveOrUpdateEntityInfo'; //添加助手信息
export const kUrlGetClassAide = adminUrl + '/admin-classAide/getClassAideById'; //获取单个助手信息
export const kUrlUpdateClassAideStatus = adminUrl + '/admin-classAide/updateClassAideStatus'; //修改助手状态
export const kUrlDeleteClassAide = adminUrl + '/admin-classAide/deleteClassAide'; //删除助手
export const kUrlExportClassAide = adminUrl + '/admin-classAide/exportClassAideList'; //导出助手
export const kUrlGetClassInfoById = adminUrl + '/admin-classInfo/getClassInfoById'; //根据班级ID获取班级信息

//线下培训助手类型
export const kUrlAideTypeListByPage = adminUrl + '/admin-aideType/queryAideTypePage'; //条件分页查询助手类型 get
export const kUrlAideTypeList = adminUrl + '/admin-aideType/queryAideTypeList'; //条件查询助手类型 get
export const kUrlAddAideType = adminUrl + '/admin-aideType/addAideType'; //新增助手类型
export const kUrlUpdateAideType = adminUrl + '/admin-aideType/updateAideType'; //编辑助手类型
export const kUrlGetAideType = adminUrl + '/admin-aideType/getAideTypeById'; //获取单个助手类型信息
export const kUrlUpdateAideTypeStatus = adminUrl + '/admin-aideType/updateAideTypeStatus'; //修改助手类型状态
export const kUrlDeleteAideType = adminUrl + '/admin-aideType/deleteAideType'; //删除助手类型
export const kUrlExportAideType = adminUrl + '/admin-aideType/exportAideTypeList'; //导出助手类型

//线下培训班级学员管理
export const kUrlClassStudentImport = adminUrl + '/admin-classStudent/importFile'; //线下培训班级学员导入 import
export const kUrlClassStudentListByPage = adminUrl + '/admin-classStudent/listByPage'; //条件查询线下培训班级学员信息 get
export const kUrlClassStudentList = adminUrl + '/admin-classStudent/list'; //条件查询线下培训班级学员信息 get
export const kUrlClassStudentById = adminUrl + '/admin-classStudent/getClassStudentById'; //根据ID查询班级学员信息 get
export const kUrlAddClassStudent = adminUrl + '/admin-classStudent/add'; //新增线下培训班级学员信息
export const kUrlUpdateClassStudent = adminUrl + '/admin-classStudent/update'; //编辑线下培训班级学员信息
export const kUrlDeleteStudentClass = adminUrl + '/admin-classStudent/delete'; //删除线下培训班级学员信息
export const kUrlExportClassStudentPerson = adminUrl + '/admin-classStudent/export'; //导出线下培训班级学员人员信息
export const kUrlExportClassStudentQuestionnaire = adminUrl + '/admin-classStudent/export'; //导出线下培训班级学员评价问卷信息
export const kUrlGetClassStudentPersonIds = adminUrl + '/admin-classStudent/getPersonIdsByClassInfoId'; //获取班级学员personIds
export const kUrlLeaveStudentClass = adminUrl + '/admin-classStudent/updateLeaveState'; //线下培训班级学员请假状态更新

//课堂助手远程认证接口
export const kUrlQueryClassStudentRemoteAuthPage = adminUrl + '/admin-classStudent/queryClassStudentRemoteAuthDetailByPage' //课堂助手远程认证列表分页接口
export const kUrlQueryClassStudentRemoteAuthList = adminUrl + '/admin-classStudent/queryClassStudentRemoteAuthDetailByList' //课堂助手远程认证列表导出接口

//课堂助手NEV认证接口
export const kUrlQueryClassStudentNEVRemoteAuthPage = adminUrl + '/admin-nevRemoteAuthDetail/queryNevRemoteAuthDetailInfoPageList' //课堂助手NEV认证列表分页接口
export const kUrlQueryClassStudentNEVRemoteAuthList = adminUrl + '/admin-nevRemoteAuthDetail/queryNevRemoteAuthDetailInfoList' //课堂助手NEV认证列表导出接口

// 课堂助手 在线课程
export const kUrlQueryClassStudentProgramPage = adminUrl + '/admin-classStudent/queryClassStudentProgramResultByPage' //课堂助手NEV认证列表分页接口
export const kUrlQueryClassStudentProgramList = adminUrl + '/admin-classStudent/queryClassStudentProgramResultByList' //课堂助手NEV认证列表导出接口

// 课堂助手 资讯
export const kUrlQueryClassStudentContentPage = adminUrl + '/admin-classStudent/queryClassStudentContentRecordByPage' //课堂助手NEV认证列表分页接口
export const kUrlQueryClassStudentContentList = adminUrl + '/admin-classStudent/queryClassStudentContentRecordByList' //课堂助手NEV认证列表导出接口

//课堂助手远程评估、课堂直播接口
export const kUrlQueryClassStudentInteractLivePage = adminUrl + '/admin-classStudent/queryClassStudentInteractLiveDetailByPage' //课堂助手远程评估、课堂直播列表分页接口
export const kUrlQueryClassStudentInteractLiveList = adminUrl + '/admin-classStudent/queryClassStudentInteractLiveDetailByList' //课堂助手远程评估、课堂直播列表导出接口
export const kUrlQueryInteractLivePage = adminUrl + '/admin-classStudent/queryInteractLiveDetailByPage' //讲师直播管理 - 课堂助手远程评估、课堂直播列表分页接口
export const kUrlQueryInteractLive = adminUrl + '/admin-classStudent/queryInteractLiveDetail' //讲师直播管理 - 课堂助手远程评估、课堂直播 导出

//课堂助手班级环节上下移
export const updateClassAideOrderNum = adminUrl + '/admin-classAide/updateClassAideOrderNum' //课堂助手班级环节上下移

// 班级公告
export const kUrlQueryClassAnnouncementPage = adminUrl + '/admin-classAnnouncement/pageList'
export const kUrlQueryClassAnnouncementList = adminUrl + '/admin-classAnnouncement/list'
export const kUrlQueryClassAnnouncementSave = adminUrl + '/admin-classAnnouncement/save'
export const kUrlQueryClassAnnouncementUpd = adminUrl + '/admin-classAnnouncement/update'

// 班级相册
export const kUrlQueryClassAlbumPage = adminUrl + '/admin-classAlbum/pageList'
export const kUrlQueryClassAlbumList = adminUrl + '/admin-classAlbum/list'
export const kUrlQueryClassAlbumAdd = adminUrl + '/admin-classAlbum/add'
export const kUrlQueryClassAlbumDel = adminUrl + '/admin-classAlbum/del'


//课堂助手远程评估2.0
export const kUrlRemoteAssessmentExamPaper = adminUrl + '/admin-remoteAuth/getRemoteAuthDetailExamPaper'
export const kUrlChangeAssessmentExamPaper = adminUrl + '/admin-remoteAuth/changeRemoteAuthDetailExamPaper'
export const kUrlUpdateAssessmentState = adminUrl + '/admin-orgRemoteAuthDetail/updateAuthState'
export const kUrlUpdateAssessmentPaper = adminUrl + '/admin-orgRemoteAuthDetail/updateAuthQuestionDetailScores'

/**
 * 调查问卷
 */
export const kUrlSurveyListByPage = adminUrl + '/admin-survey/pageList'; //调查问卷列表
export const kUrlGetSurveyInfo = adminUrl + '/admin-survey/findSurveyInfoById'//调查问卷详情
export const kUrlSurveyAdd = adminUrl + '/admin-survey/add';//调查问卷新增
export const kUrlSurveyUpdate = adminUrl + '/admin-survey/update';//调查问卷修改
export const kUrlSurveyBatchDelete = adminUrl + '/admin-survey/batchDelete';//调查问卷 批量删除
export const kUrlSurveyUpdateState = adminUrl + '/admin-survey/updateState';//调查问卷 发布/关闭
export const kUrlCreateQuestions = adminUrl + '/admin-survey/createQuestionsForSurvey' //新增问卷设计（题目）
export const kUrlUpdateQuestions = adminUrl + '/admin-survey/updateQuestionsForSurvey' //新增问卷设计（题目）
export const kUrlSurveyExport = adminUrl + '/admin-survey/export';//调查问卷 导出
export const kUrlSurveyAnswerPageList = adminUrl + '/admin-survey/surveyAnswerList';//调查问卷 问卷收集记录
export const kUrlSurveyTargetScopeInfo = adminUrl + '/admin-survey/targetScopeInfo';//问卷 受众及人数信息
export const kUrlSurveyAuthInfo = adminUrl + '/admin-survey/authInfo';//问卷设置受众信息
export const kUrlSurveySaveAuth = adminUrl + '/admin-survey/saveAuth';//问卷保存受众信息
export const kUrlSurveyResult = adminUrl + '/admin-survey/surveyAnswerRecord';//获取问卷记录
export const kUrlFindSurveyAnswerById = adminUrl + '/admin-survey/findSurveyAnswerById'//获取问卷答卷 报名审核用
export const kUrlSurveyAnswerList = adminUrl + '/admin-surveyAnswer/surveyAnswerList';//调查问卷 问卷收集记录

export const kUrlSurveyTemplateListByPage = adminUrl + '/admin-surveyTemp/pageList';//问卷模版列表
export const kUrlGetSurveyTemplateInfo = adminUrl + '/admin-surveyTemp/findSurveyTemplateInfoById'//调查问卷模版详情
export const kUrlSurveyTemplateAdd = adminUrl + '/admin-surveyTemp/add';//问卷模版新增
export const kUrlSurveyTemplateUpdate = adminUrl + '/admin-surveyTemp/update';//问卷模版修改
export const kUrlSurveyTemplateUpdateState = adminUrl + '/admin-surveyTemp/updateState';//问卷模版 状态修改
export const kUrlSurveyTemplateBatchDelete = adminUrl + '/admin-surveyTemp/batchDelete';//问卷模版 批量删除
export const kUrlCreateTemplateQuestions = adminUrl + '/admin-surveyTemp/createQuestionsForSurveyTemplate' //新增问卷模版设计（题目）
export const kUrlUpdateTemplateQuestions = adminUrl + '/admin-surveyTemp/updateQuestionsForSurveyTemplate' //新增问卷模版设计（题目）

//课堂助手查看考试-图表接口
export const kUrlQueryClassExamInfo = adminUrl + '/admin-classStudent/queryClassExamInfo' //获取课堂助手考试查看图表接口
export const kUrlQueryStudentExamPage = adminUrl + '/admin-classStudent/queryStudentExamPage' //课堂助手考试查看列表接口
export const kUrlExportStudentExamByCondition = adminUrl + '/admin-classStudent/exportStudentExamByCondition' //按已选任职导出成绩
export const kUrlExportStudentExamByAllIdentity = adminUrl + '/admin-classStudent/exportStudentExamByAllIdentity' //按已选任职导出成绩
//课堂助手查看问卷接口
export const kUrlQueryClassStudentSurveySummary = adminUrl + '/admin-classStudent/queryClassStudentSurveySummary' //课堂助手查看问卷图表接口
export const kUrlQueryClassStudentSurveyPage = adminUrl + '/admin-classStudent/queryClassStudentSurveyPage' //课堂助手查看问卷列表分页接口
export const kUrlExportClassStudentSurveyByCondition = adminUrl + '/admin-classStudent/exportClassStudentSurveyByCondition' //导出问卷班级学员问卷信息接口
export const kUrlExportClassStudentSurveyDetailByCondition = adminUrl + '/admin-classStudent/exportClassStudentSurveyDetailByCondition' // 导出问卷班级学员问卷信息接口

//课堂助手查看作业接口
export const kUrlQueryClassStudentHomeworkPage = adminUrl + '/admin-classStudent/queryClassStudentHomeworkDetailPage' //课堂助手查看作业列表分页接口
export const kUrlexportClassStudentHomework = adminUrl + '/admin-classStudent/exportClassStudentHomework' //课堂助手作业列表导出接口

/**
 * 场地管理
 */
//培训中心管理
export const kUrlTrainCenterPage = adminUrl + '/admin-trainCenter/pageList';
export const kUrlTrainCenterAdd = adminUrl + '/admin-trainCenter/add';
export const kUrlTrainCenterUpdate = adminUrl + '/admin-trainCenter/update';
export const kUrlTrainCenterList = adminUrl + '/admin-trainCenter/list';
//培训中心场地管理
export const kUrlTrainSitePage = adminUrl + '/admin-trainSite/pageList';
export const kUrlTrainSiteAdd = adminUrl + '/admin-trainSite/add';
export const kUrlTrainSiteUpdate = adminUrl + '/admin-trainSite/update';
export const kUrlTrainSiteLook = adminUrl + '/admin-trainSite/getById';
export const kUrlTrainSiteExport = adminUrl + '/admin-trainSite/export'
//教室管理
export const kUrlClassroomListByPage = adminUrl + '/admin-classroom/listByPage'
export const kUrlClassroomCreate = adminUrl + '/admin-classroom/createClassroom'
export const kUrlClassroomUpdate = adminUrl + '/admin-classroom/updateClassroom'
//场地设备管理
export const kUrlSiteEquipmentListByPage = adminUrl + '/admin-siteEquipment/listByPage'
export const kUrlSiteEquipmentCreate = adminUrl + '/admin-siteEquipment/createSiteEquipment'
export const kUrlSiteEquipmentUpdate = adminUrl + '/admin-siteEquipment/updateSiteEquipment'
export const kUrlSiteEquipmentExport = adminUrl + '/admin-siteEquipment/export'

//场地预约管理
export const kUrlTrainSiteAppointmentList = adminUrl + '/admin-trainSite/appointmentList';
export const kUrlSiteOrderListByPage = adminUrl + '/admin-siteOrder/listByPage'
export const kUrlSiteOrderList = adminUrl + '/admin-siteOrder/list'
export const kUrlCreateSiteOrder = adminUrl + '/admin-siteOrder/createSiteOrder'
export const kUrlUpdateSiteOrder = adminUrl + '/admin-siteOrder/updateSiteOrder'
export const kUrlCancel = adminUrl + '/admin-siteOrder/cancel'
export const kUrlAppointmentReview = adminUrl + '/admin-siteOrder/appointmentReview'
export const kUrlSiteOrderExport = adminUrl + '/admin-siteOrder/export'
//场地核实
export const kUrlSiteOrderCheckListByPage = adminUrl + '/admin-siteOrderCheck/listByPage'
export const kUrlVerifySiteOrderCheck = adminUrl + '/admin-siteOrderCheck/verifySiteOrderCheck'
//场地统计
export const kUrlAppointmentStatistic = adminUrl + '/admin-siteOrder/siteAppointmentStatistic'
export const kUrlVerifyStatistic = adminUrl + '/admin-siteOrder/siteVerifyStatistic'
export const kUrlExportVerify = adminUrl + '/admin-siteOrder/exportVerify'
export const kUrlAppointmentArrangement = adminUrl + '/admin-siteOrder/siteAppointmentArrangement'
export const kUrlExportAppointmentArrangement = adminUrl + '/admin-siteOrder/exportAppointmentArrangement'


//消息管理
export const kUrlMessageTaskListByPage = baseUrl + '/base-noticeTemplate/listByPage' //获取消息
export const kUrlMessageTaskSave = baseUrl + '/base-noticeTemplate/save' //保存消息
export const kUrlGetNoticeInfoList = baseUrl + '/base-noticeTemplate/queryNoticeInfoList' //获取消息推送信息
export const kUrlSaveNoticeDefine = adminUrl + '/admin-noticeTemplate/saveNoticeDefine' //发送消息推送信息
export const kUrlGetTaskNoticeInfoList = baseUrl + '/base-noticeTemplate/queryTaskNoticeInfoList' //获取任务消息推送信息
export const kUrlVoiceMsgListByPage = baseUrl + '/base-noticeTemplate/voiceMsgListByPage' //语音通知模版列表

export const kUrlSaveTaskNoticeDefine = baseUrl + '/base-noticeTemplate/saveTaskNoticeDefine' //获取消息推送信息

//岗位能力评估
export const kUrlAbilityCheckCategoryListByPage = adminUrl + '/admin-abilityCheckCategory/listByPage'
export const kUrlAbilityCheckCategoryList = adminUrl + '/admin-abilityCheckCategory/export'
export const kUrlAbilityCheckCategoryAdd = adminUrl + '/admin-abilityCheckCategory/add'
export const kUrlAbilityCheckCategoryUpdate = adminUrl + '/admin-abilityCheckCategory/update'
export const kUrlAbilityCheckCategoryUpdateState = adminUrl + '/admin-abilityCheckCategory/updateState'
export const kUrlGetStudentAllAbilityItemByPersonId = adminUrl + '/admin-studentAbilityItem/getStudentAllAbilityItemByPersonId'

//能力项
export const kUrlAbilityItemListByCondition = adminUrl + '/admin-abilityItem/listByCondition'
export const kUrlAbilityItemBatchSave = adminUrl + '/admin-abilityItem/batchSave'
export const kUrlStudentAbilityItemGetPageList = adminUrl + '/admin-studentAbilityItem/getPageList'
export const kUrlAbilityItemDelItmeById = adminUrl + '/admin-abilityItem/delItmeById'

//岗位能力评估星级
export const kUrlAbilityCheckItemListByPage = adminUrl + '/admin-abilityCheckItem/pageList'
export const kUrlAbilityCheckItemList = adminUrl + '/admin-abilityCheckItem/listByCondition'
export const kUrlAbilityCheckItemAdd = adminUrl + '/admin-abilityCheckItem/add'
export const kUrlAbilityCheckItemUpdate = adminUrl + '/admin-abilityCheckItem/update'
export const kUrlAbilityCheckItemBatchDelete = adminUrl + '/admin-abilityCheckItem/batchDelete'
export const kUrlAbilityCheckItemUpdateState = adminUrl + '/admin-abilityCheckItem/updateState'
export const kUrlAbilityCheckItemExport = adminUrl + '/admin-abilityCheckItem/export'

//能力项详情
export const kUrlAbilityItemDetailListByPage = adminUrl + '/admin-abilityItemDetail/pageList'
export const kUrlAbilityItemDetailList = adminUrl + '/admin-abilityItemDetail/listByCondition'
export const kUrlAbilityItemDetailListItems = adminUrl + '/admin-abilityItemDetail/listItemsByCondition'
export const kUrlAbilityItemDetailAdd = adminUrl + '/admin-abilityItemDetail/add'
export const kUrlAbilityItemDetailUpdate = adminUrl + '/admin-abilityItemDetail/update'
export const kUrlAbilityItemDetailBatchDelete = adminUrl + '/admin-abilityItemDetail/batchDelete'
export const kUrlAbilityItemDetailUpdateState = adminUrl + '/admin-abilityItemDetail/updateState'

//学员能力岗位评估查询人员
export const kUrlListByPageForAbility = baseUrl + '/base-personInfo/listByPage'

//学员能力岗位评估
export const kUrlStudentAbilityItemAdd = adminUrl + '/admin-studentAbilityItem/add'
export const kUrlStudentAbilityItemGetExportHead = adminUrl + '/admin-studentAbilityItem/getExportHead'
export const kUrlStudentAbilityItemImportFile = adminUrl + '/admin-studentAbilityItem/importFile'
export const kUrlStudentAbilityItemUpdate = adminUrl + '/admin-studentAbilityItem/update'
export const kUrlStudentAbilityItemExport = adminUrl + '/admin-studentAbilityItem/export'
export const kUrlStudentAbilityItemDel = adminUrl + '/admin-studentAbilityItem/del'
//获取以获得的学员能力岗位评估星级人员ID集合
export const kUrlGetStudentAbilityItemPersonIdList = adminUrl + '/admin-studentAbilityItem/getPersonIdByItemId'


//路径
export const kUrlGetTrainPath = adminUrl + '/admin-trainPath/pageList'
export const kUrlTrainPathAdd = adminUrl + '/admin-trainPath/add'
export const kUrlTrainPathUpd = adminUrl + '/admin-trainPath/upd'
export const kUrlTrainPathUpdateState = adminUrl + '/admin-trainPath/updateState'
export const kUrlTrainPathDel = adminUrl + '/admin-trainPath/del'
export const kUrlTrainPathExportInfo = adminUrl + '/admin-trainPath/exportTrainPathInfo'
export const kUrlTrainPathExportContent = adminUrl + '/admin-trainPath/getPathContent'
export const kUrlTrainPathFileImport = adminUrl + '/admin-trainPath/import'

//路径阶段
export const kUrlTrainPathStageList = adminUrl + '/admin-trainPathStageController/list'
export const kUrlTrainPathStageAdd = adminUrl + '/admin-trainPathStageController/insert'
export const kUrlTrainPathStageUpd = adminUrl + '/admin-trainPathStageController/update'
export const kUrlTrainPathStageGetPathInfo = adminUrl + '/admin-trainPathStageController/getPathInfo'
export const kUrlTrainPathStageSort = adminUrl + '/admin-trainPathStageController/sort'
export const kUrlTrainPathStageDelete = adminUrl + '/admin-trainPathStageController/delete'
export const kUrlTrainPathStageCloseOrRelease = adminUrl + '/admin-trainPathStageController/closeOrRelease'
export const kUrlTrainPathStageGetStudentPathList = adminUrl + '/admin-trainPathStageController/getStudentPathList'
export const kUrlTrainPathStageGetStudentPathInfo = adminUrl + '/admin-trainPathStageController/getStudentPathInfo'
export const kUrlTrainPathStageListPage = adminUrl + '/admin-trainPathStageController/getPathStageList'
export const kUrlTrainPathStageGetCommentStudentPathInfo = adminUrl + '/admin-trainPathStageController/getCommentStudentPathInfo'
export const kUrlTrainPathStageListPageOnScoreRule = adminUrl + '/admin-trainPathStageController/getPathStageListOnStageScore'



//路径任务
export const kUrlTrainPathTaskList = adminUrl + '/admin-trainPathTask/list'
export const kUrlTrainPathTaskAdd = adminUrl + '/admin-trainPathTask/add'
export const kUrlTrainPathTaskUpdateState = adminUrl + '/admin-trainPathTask/updateState'
export const kUrlTrainPathTaskDel = adminUrl + '/admin-trainPathTask/del'
export const kUrlTrainPathTaskUpdateSort = adminUrl + '/admin-trainPathTask/updateSort'
export const kUrlTrainPathTaskUpdateSortAll = adminUrl + '/admin-trainPathTask/updateSortAll'
export const kUrlTrainPathTaskUpd = adminUrl + '/admin-trainPathTask/upd'
export const kUrlGetTrainPathCommentStageInfo = adminUrl + '/admin-trainPathTask/getTrainPathCommentStageInfo'



//路径评语
export const kUrlGetTrainPathCommentPageList = adminUrl + '/admin-trainPathComment/pageList'
export const kUrlGetTrainPathCommentList = adminUrl + '/admin-trainPathComment/list'
export const kUrlTrainPathCommentAdd = adminUrl + '/admin-trainPathComment/add'
export const kUrlTrainPathCommentUpd = adminUrl + '/admin-trainPathComment/upd'
export const kUrlTrainPathCommentUpdateState = adminUrl + '/admin-trainPathComment/updateState'
export const kUrlTrainPathCommentDel = adminUrl + '/admin-trainPathComment/del'
export const kUrlTrainPathCommentTargetScopeInfo = adminUrl + '/admin-trainPathComment/targetScopeInfo';

//路径评语明细
export const kUrlGetTrainPathCommentDetailedPageList = adminUrl + '/admin-trainPathCommentDetailed/pageList'
export const kUrlGetTrainPathCommentDetailedList = adminUrl + '/admin-trainPathCommentDetailed/list'

//路径成绩计算规则
export const kUrlTrainPathStageScoreRulePageList = adminUrl + '/admin-trainPathStageScoreRule/getPageList'
export const kUrlTrainPathStageScoreRuleAdd = adminUrl + '/admin-trainPathStageScoreRule/add'
export const kUrlTrainPathStageScoreRuleUpd = adminUrl + '/admin-trainPathStageScoreRule/upd'
export const kUrlTrainPathStageScoreRuledel = adminUrl + '/admin-trainPathStageScoreRule/del'
export const kUrlTrainPathStageScoreRuleEnable = adminUrl + '/admin-trainPathStageScoreRule/updateState'

//学员路径评语记录相关
export const kUrlGetStudentCommentPageList = adminUrl + '/admin-studentComment/studentCommentListByPage'
export const kUrlGetStudentCommentList = adminUrl + '/admin-studentComment/studentCommentList'
export const kUrlStudentCommentAdd = adminUrl + '/admin-studentComment/add'
export const kUrlStudentCommentUpd = adminUrl + '/admin-studentComment/upd'
export const kUrlStudentCommentUpdateState = adminUrl + '/admin-studentComment/updateState'
export const kUrlStudentCommentDel = adminUrl + '/admin-studentComment/del'
export const kUrlStudentCommentSelectOneById = adminUrl + '/admin-studentComment/selectOneById';
export const kUrStudentCommentExport = adminUrl + '/admin-studentComment/exportStudentCommentList';

//学员路径评语记录明细相关
export const kUrlGetStudentCommentDetailPageList = adminUrl + '/admin-studentCommentDetail/studentCommentDetailListByPage'
export const kUrlGetStudentCommentDetailList = adminUrl + '/admin-studentCommentDetail/studentCommentDetailList'
export const kUrlStudentCommentDetailAdd = adminUrl + '/admin-studentCommentDetail/add'
export const kUrlStudentCommentDetailUpd = adminUrl + '/admin-studentCommentDetail/upd'
export const kUrlStudentCommentDetailDel = adminUrl + '/admin-studentCommentDetail/del'
export const kUrlStudentCommentDetailSelectOneById = adminUrl + '/admin-studentComment/selectOneById';

//新开业培训管理
export const kUrlGetRequirementDetailPageList = adminUrl + '/admin-requirement/getPageList'
export const kUrlGetRequirementDetailExport = adminUrl + '/admin-requirement/export'
export const kUrlGetRequirementDetailList = adminUrl + '/admin-requirement/getList'
export const kUrlRequirementDetailAdd = adminUrl + '/admin-requirement/add'
export const kUrlRequirementDetailUpd = adminUrl + '/admin-requirement/upd'
export const kUrlRequirementDetailDel = adminUrl + '/admin-requirement/delete'
export const kUrlRequirementDetailSelectOneById = adminUrl + '/admin-requirement/selectRequirementById';
export const kUrlRequirementDetailUpdateState = adminUrl + '/admin-requirement/updateState';
export const kUrlGetRequirementDataPageList = adminUrl + '/admin-requirementData/getPageList'//新开业培训记录列表
export const kUrlGetRequirementDataDetailList = adminUrl + '/admin-requirementDataDetail/getList' //新开业培训记录详情
export const kUrlRequirementPartTimePositionPageList = adminUrl + '/admin-requirementPartTimePosition/pageList'
export const kUrlRequirementPartTimePositionPageAdd= adminUrl + '/admin-requirementPartTimePosition/add'
export const kUrlRequirementPartTimePositionPageUpd= adminUrl + '/admin-requirementPartTimePosition/update'
export const kUrlRequirementPartTimePositionPageDel= adminUrl + '/admin-requirementPartTimePosition/delete'
export const kUrlRequirementPartTimePositionPageEnable= adminUrl + '/admin-requirementPartTimePosition/updateStatus'

//考核要求名称配置管理
export const kUrlGetRequirementConfigPageList = adminUrl + '/admin-requirementTitleConfig/pageList'
export const kUrlGetRequirementConfigList = adminUrl + '/admin-requirementTitleConfig/list'
export const kUrlRequirementConfigAdd = adminUrl + '/admin-requirementTitleConfig/add'
export const kUrlRequirementConfigUpd = adminUrl + '/admin-requirementTitleConfig/update'
export const kUrlRequirementConfigSelectOneById = adminUrl + '/admin-requirementTitleConfig/getInfo';
export const kUrlRequirementConfigUpdateState = adminUrl + '/admin-requirementTitleConfig/updateStatus';

//新开业人员培训
export const kUrlGetRequirementPersonnelPageList = adminUrl + '/admin-requirementPersonnel/getPageList'
export const kUrlGetRequirementPersonnelList = adminUrl + '/admin-requirementPersonnel/getList'
export const kUrlRequirementPersonnelConfirm = adminUrl + '/admin-requirementPersonnel/complianceConfirmation'
export const kUrlRequirementPersonnelExportTypeReport = adminUrl + '/admin-requirementPersonnel/queryExportRequirementPersonnelReport'

//新开业人员培训详情
export const kUrlGetRequirementPersonnelDetailPageList = adminUrl + '/admin-requirementPersonnelDetail/getPageList'
export const kUrlGetRequirementPersonnelDetailList = adminUrl + '/admin-requirementPersonnelDetail/getList'
export const kUrlRequirementPersonnelDetailSaveOrUpdateState = adminUrl + '/admin-requirementPersonnelDetail/saveOrUpdateState'
export const kUrlRequirementPersonnelDetailImportFile = adminUrl + '/admin-requirementPersonnelDetail/importFile'
export const kUrlGetRequirementPersonnelDetailHeadList = adminUrl + '/admin-requirementPersonnel/getHeadList'

//新开业测评报名管理
export const kUrlGetRequirementPersonnelApplyList = adminUrl + '/admin-requirementPersonnelApply/listByPage'

//经销商新人培训列表
export const kUrlGetDealerNewComerTrainingPageList = adminUrl + '/admin-dealerNewComerTraining/getPageList'
export const kUrlGetDealerNewComerTrainingExport = adminUrl + '/admin-dealerNewComerTraining/export'
export const kUrlDealerNewComerTrainingUpdateState = adminUrl + '/admin-dealerNewComerTraining/updateState'
//新人培训详情
export const kUrlRequirementOrgPersonPageList = adminUrl + '/admin-requirementOrgPerson/queryInfoPageList'
export const kUrlRequirementOrgPersonExport = adminUrl + '/admin-requirementOrgPerson/queryInfoList'
export const kUrlRequirementOrgPersonTrainExport = adminUrl + '/admin-requirementOrgPerson/queryExportRequirementOrgPersonInfoReport'
export const kUrlRequirementOrgPersonTrainGetInfo = adminUrl + '/admin-requirementOrgPerson/getInfo'
export const kUrlRequirementOrgPersonTrainUpdateStatus = adminUrl + '/admin-requirementOrgPerson/updateStatus'
export const kUrlRequirementOrgPersonTrainUpdateOldOrgNewPerson = adminUrl + '/admin-requirementOrgPerson/updateOldOrgNewPerson'

/**
 * 流程管理
 */
//模型
export const kUrlModelListByPage = workflowPath + '/model/listByPage'  //流程模型列表分页查询
export const kUrlAddModel = workflowHttpPath + '/model/addModel'  //新增模型
export const kUrlDeleteModel = workflowPath + '/model/deleteModel'  //删除模型
export const kUrlUpdateModel = workflowHttpPath + '/model/updateModel'  //修改模型
export const kUrlDeployModel = workflowPath + '/model/deployModel'  //发布模型为流程定义
//流程定义
export const kUrlProcdefListByPage = workflowPath + '/procdef/listByPage'  //流程定义列表分页查询
export const kUrlDeleteProcdef = workflowPath + '/procdef/deleteProcdef'  //删除流程定义
export const kUrlUpdateProcdefSuspensionState = workflowPath + '/procdef/updateSuspensionState'  //挂起/激活流程定义
export const kUrlViewProcedefResource = workflowPath + '/procdef/viewResource'  //查看流程定义资源文件
//请假
export const kUrlWorkflowAuditListByPage = workflowPath + '/workflowAudit/listByPage'  //审核流程分页列表查询
export const kUrlSaveAudiSt = workflowPath + '/workflowAudit/saveAudit'  //保存审核流程基本信息
export const kUrlAuditUserSaveAuth = workflowPath + '/workflowAudit/saveAuth'  //保存审核权限范围
export const kUrlAuditAuthInfo = workflowPath + '/workflowAudit/authInfo'  //获取审核权限范围
export const kUrlWorkflowAuditMethodListByPage = workflowPath + '/workflowAudit/auditMethodListByPage'  //审核流程方法信息
export const kUrlUpdateLeave = workflowPath + '/leave/updateLeave'  //修改请假
export const kUrlSubmitWorkflowLeave = workflowPath + '/leave/submitWorkflow'  //提交请假流程
//流程配置
export const kUrlNodeList = workflowPath + '/node/list'  //节点列表
export const kUrlNodeGetAuth = workflowPath + '/node/getAuth'  //获取节点权限
export const kUrlNodeSaveAuth = workflowPath + '/node/saveAuth'  //保存节点权限
//流程实例
export const kUrlProcinsRunListByPage = adminUrl + '/admin-procins/runListByPage'  //运行中流程列表分页查询
export const kUrlProcinsEndListByPage = adminUrl + '/admin-procins/endListByPage'  //结束的流程列表分页查询
export const kUrlUpdateProcinsSuspensionState = adminUrl + '/admin-procins/updateSuspensionState'  //挂起/激活流程实例
//审核详情

export const kUrlAuditInfoFlowListByPage = workflowPath + '/auditInfo/flowListByPage'  //审批流转历史
export const kUrlAuditInfoBusinessInfo = workflowPath + '/auditInfo/businessInfo'  //流程基本信息
export const kUrlAuditInfobusinessAuditInfoList = workflowPath + '/auditInfo/businessAuditInfoList'  //流程详情中的审核
export const kUrlAuditInfobusinessAuditInfo = workflowPath + '/auditInfo/businessAuditInfo'  //流程详情中的审核
export const kUrlAuditInfoAuditMainInfo = workflowPath + '/auditInfo/auditMainInfo'  //流程详情中的流程基本信息

export const kUrlAuthPersonListByPage = workflowPath + '/auditInfo/auditPersonInfo'  //流程详情中的流程基本信息

export const kUrlFindIdentities = baseUrl + '/base-personInfo/findPersonOptionalUserIdentities'  //流程详情中的流程基本信息


//流程任务
export const kUrlProcTaskFlowListByPage = adminUrl + '/auditInfo/flowListByPage'  //审批流转历史
export const kUrlProcTaskTodoListByPage = adminUrl + '/admin-procTask/todoListByPage'  //我的待办
export const kUrlProcTaskDoneListByPage = adminUrl + '/admin-procTask/doneListByPage'  //我的已办
export const kUrlProcTaskOutComeList = adminUrl + '/admin-procTask/outComeList'  //当前任务完成后连线名称
export const kUrlProcTaskAudit = adminUrl + '/admin-procTask/audit'  //提交审核
export const kUrlProcTaskCurrTaskImg = workflowPath + '/procTask/currTaskImg'  //高亮任务节点流程图


/** 远程认证 旧平台 */
//远程认证主体列表页
export const kUrlRemoteAuthAdd = adminUrl + '/admin-remoteAuth/addRemoteAuthByPower' //远程认证项目新增
export const kUrlRemoteAuthUpd = adminUrl + '/admin-remoteAuth/updateRemoteAuthByPower' //远程认证项目更新
export const kUrlRemoteAuthListByPage = adminUrl + '/admin-remoteAuth/listByPage' //列表查询
export const kUrlRemoteAuthListExport = adminUrl + '/admin-remoteAuth/export' //列表导出
export const kUrlRemoteAuthReport = adminUrl + '/admin-studentRemoteAuthDetail/getReportData' //报告下载
export const kUrlRemoteAuthImport = adminUrl + '/admin-remoteAuth/import'//考卷上传
export const kUrlRemoteAuthImportNew = adminUrl + '/admin-remoteAuth/importRemoteAuthExam'//远程评估考卷上传
export const kUrlFileRemoteAuthRelationList = adminUrl + '/admin-fileRemoteAuthRelation/listByPage' //考卷上传文件列表
export const kUrlRemoteAuthImportScore = adminUrl + '/admin-studentRemoteAuthDetail/remoteAuthImportScore' //认证成绩导入接口
export const kUrlExportRemoteAuthInfo = adminUrl + '/admin-studentRemoteAuthDetail/exportRemoteAuthInfo' //报告下载new

//远程评估new 20210716
export const kUrlRemoteAuthPositionConfig = adminUrl + '/admin-remoteAuth/getRemoteAuthPositionConfig'//获取检核远程项目岗位配置
export const kUrlRemoteAuthConfigPersonInfoList = adminUrl + '/admin-remoteAuth/getRemoteAuthConfigPersonInfoList' //检核项目远程评估获取组织配置人员信息

//远程评估详情new 20210721
export const kUrlAddOrgRemoteAuthDetail = adminUrl + '/admin-orgRemoteAuthDetail/addOrgRemoteAuthDetail'//新增
export const kUrlUpdateOrgRemoteAuthDetail = adminUrl + '/admin-orgRemoteAuthDetail/updateOrgRemoteAuthDetail' //编辑
export const kUrlGetListByPage = adminUrl + '/admin-orgRemoteAuthDetail/listByPage'//分页查询
export const kUrlExport = adminUrl + '/admin-orgRemoteAuthDetail/export' //导出
export const kUrlEvaluationImportScore = adminUrl + '/admin-orgRemoteAuthDetail/remoteAuthImportScore' //成绩导入
export const kUrlSelectOneById = adminUrl + '/admin-orgRemoteAuthDetail/selectOneById'//查询单个检核项目远程评估信息
export const kUrlOrgRemoteAuthDetailInteractLiveRecordPage = adminUrl + '/admin-orgRemoteAuthDetail/queryOrgRemoteAuthDetailInteractLiveRecordByPage'//参训记录列表
export const kUrlOrgRemoteAuthDetailInteractLiveRecordExport = adminUrl + '/admin-orgRemoteAuthDetail/queryOrgRemoteAuthDetailInteractLiveRecordByList'//参训记录导出
export const kUrlGetOrgRemoteAuthExamInfo = adminUrl + '/admin-orgRemoteAuthDetail/listExamInfoByCondition' //获取远程评估试卷
export const kUrlUpdateAuthQuestionDetailScores = adminUrl + '/admin-authQuestionDetailScore/updateAuthQuestionDetailScores' //远程评估修改分数

//远程认证详情列表页
export const kUrlRemoteAuthImportScoreRe = adminUrl + '/admin-studentRemoteAuthDetail/remoteAuthImportScoreRe' //认证成绩导入接口 20201226
export const kUrlStudentRemoteAuthDetailPublishStateRe = adminUrl + '/admin-studentRemoteAuthDetail/updatePublishStateRe' //远程认证成绩发布 20201226
export const kUrlStudentRemoteAuthDetailListByPage = adminUrl + '/admin-studentRemoteAuthDetail/listByPage' //远程认证详情列表查询
export const kUrlStudentRemoteAuthDetailList = adminUrl + '/admin-studentRemoteAuthDetail/list' //远程认证详情条件查询
export const kUrlModuleRelationSave = adminUrl + '/admin-studentModuleRelation/save' //保存成绩
export const kUrlStudentRemoteAuthDetailPublishState = adminUrl + '/admin-studentRemoteAuthDetail/updatePublishState' //远程认证成绩发布
export const kUrlSetStudentRemoteAuthOwnerId = adminUrl + '/admin-studentRemoteAuthDetail/setStudentRemoteAuthOwnerId' //设置讲师
export const kUrlGetStudentRemoteAuthExamInfo = adminUrl + '/admin-studentRemoteAuthDetail/listExamInfoByCondition' //获取远程认证学员试卷
export const kUrlGetCheckStudentRemoteAuthResources = adminUrl + '/admin-studentRemoteAuthDetail/checkStudentRemoteAuthResources' //获取远程认证学员试卷
export const kUrlGetStudentRemoteAuthVideo = adminUrl + '/admin-studentRemoteAuthDetail/getStudentRemoteAuthVideo' //设置讲师
export const kUrlBatchUpdateStudentRemoteAuthDetail = adminUrl + '/admin-studentRemoteAuthDetail/batchUpdateStudentRemoteAuthDetail' //批量更新学员认证设置信息
//NEV认证详情列表页
export const kUrlNevRemoteAuthDetailByPage = adminUrl + '/admin-nevRemoteAuthDetail/queryNevRemoteAuthDetailInfoPageList' //NEV认证详情列表查询
export const kUrlNevRemoteAuthDetailByList = adminUrl + '/admin-nevRemoteAuthDetail/queryNevRemoteAuthDetailInfoList' //NEV认证详情集合查询
export const kUrlNevRemoteAuthDetailExamInfo = adminUrl + '/admin-nevRemoteAuthDetail/getNevRemoteAuthExamInfo' //NEV认证考卷详情信息查询
export const kUrlSaveNevExamPaper = adminUrl + '/admin-nevRemoteAuthDetail/saveNevExamPaper' //NEV认证考卷保存信息接口
export const kUrlBatchConfigNevRemoteAuthDetail = adminUrl + '/admin-nevRemoteAuthDetail/batchConfigNevRemoteAuthDetail' //NEV认证批量配置接口

export const kUrlCompetencyCertificationModel = adminUrl + '/admin-nevRemoteAuthDetail/getNevRemoteAuthExamInfo'//NEV能力认证模型
export const kUrlNEVUpdateAuthState = adminUrl + '/admin-nevRemoteAuthDetail/updateAuthState' //NEV认证修改认证状态

/**
 * 报名管理
 */
//
//报名管理
export const kUrlApplyListByPage = adminUrl + '/admin-apply/listByPage'
export const kUrlApplyUpdateApply = adminUrl + '/admin-apply/updateApply'
export const kUrlApplyDeleteApply = adminUrl + '/admin-apply/deleteApply'
export const kUrlApplyExportApply = adminUrl + '/admin-apply/exportApply'
export const kUrlApplyAddApply = adminUrl + '/admin-apply/addApply'
export const kUrlApplyChangeState = adminUrl + '/admin-apply/enableApply'
export const kUrlApplyStudentRecordPage = adminUrl + '/admin-apply/queryApplyStudentRecordPage'
export const kUrlApplyVerifyList = adminUrl + '/admin-applyAudit/listByPage'
export const kUrlApplyPrep = adminUrl + '/admin-applyAudit/auditApplyPrep'
export const kUrlAuditApplyInfo = adminUrl + '/admin-applyAudit/auditApplyInfo'
export const kUrlLookAuditInfo = adminUrl + '/admin-applyAudit/look'
export const kUrlDeleteAuditApply = adminUrl + '/admin-applyAudit/deleteAuditApply'
export const kUrlExportAuditApply = adminUrl + '/admin-applyAudit/applyAuditList'
export const kUrlBatchAuditApplyInfo = adminUrl + '/admin-applyAudit/batchAuditApplyInfo' //批量审核
export const kUrlSyncUpdatePlan = adminUrl + '/admin-apply/syncUpdatePlan' //同步班级信息
export const kUrlApplySurveyAnswerList = adminUrl + '/admin-apply/surveyAnswerList' //导出回执信息

//报名安排
export const kUrlApplyPlanEnable = adminUrl + '/admin-applyPlan/enable'
export const kUrlApplyPlanList = adminUrl + '/admin-applyPlan/listByPage'
export const kUrlPlanList = adminUrl + '/admin-applyPlan/list'
export const kUrlApplyPlanAdd = adminUrl + '/admin-applyPlan/addPlan'
export const kUrlApplyPlanUpdate = adminUrl + '/admin-applyPlan/updatePlan'
export const kUrlApplyPlanDelete = adminUrl + '/admin-applyPlan/deletePlan'
export const kUrlCreateApplyPlans = adminUrl + '/admin-apply/createApplyPlans'
export const kUrlUpdateApplyPlans = adminUrl + '/admin-apply/updateApplyPlans'
export const kUrlGetApplyInfo = adminUrl + '/admin-apply/findApplyInfoById'
export const kUrlPlanPageList = adminUrl + '/admin-applyPlan/planPageList'
export const kUrlAdjustPlanList = adminUrl + '/admin-applyPlan/queryAdjustPlanList'
export const kUrlExportApplyStudentGrades = adminUrl + '/admin-applyPlan/exportStudentGrades'


//受众范围
export const kUrlApplyTargetScopeInfo = adminUrl + '/admin-apply/targetScopeInfo'
export const kUrlApplyAuthInfo = adminUrl + '/admin-apply/authInfo'
export const kUrlApplySaveAuth = adminUrl + '/admin-apply/saveAuth'
//报名记录
export const kUrlApplyRecordList = adminUrl + '/admin-apply/recordPageList'
export const kUrlApplyRecordAdd = adminUrl + '/admin-apply/addApplyStudent'
export const kUrlApplyRecordImport = adminUrl + '/admin-apply/importApplyStudent'
export const kUrlApplyStudentDelete = adminUrl + '/admin-apply/deleteApplyRecord'
export const kUrlBatchCancelledApplyRecord = adminUrl + '/admin-applyRecord/batchCancelledApplyRecord'
//远程认证
export const kUrlGetStudentExamPaper = adminUrl + '/admin-studentRemoteAuthDetail/getStudentExamPaper' //远程认证获取考卷
export const kUrlChangeStudentExamPaper = adminUrl + '/admin-studentRemoteAuthDetail/changeStudentExamPaper' //远程更换考卷
export const kUrlSaveStudentExamPaper = adminUrl + '/admin-studentRemoteAuthDetail/saveStudentExamPaper'  //远程认证保存考卷
export const kUrlUpdateAuthState = adminUrl + '/admin-studentRemoteAuthDetail/updateAuthState' //远程认证修改认证状态
export const kUrlChangeModuleState = adminUrl + '/admin-studentRemoteAuthDetail/changeModuleState' //远程认证开始/结束模块

//证书中心
export const kUrlCertListByPage = adminUrl + '/admin-cert/listByPage' //证书列表
export const kUrlCertAdd = adminUrl + '/admin-cert/add' //证书新增
export const kUrlCertUpdate = adminUrl + '/admin-cert/update'  //证书更新
export const kUrlCertDelete = adminUrl + '/admin-cert/delete' //证书删除
export const kUrlCertUpdateState = adminUrl + '/admin-cert/updateState' //证书更新状态
export const kUrlCertExport = adminUrl + '/admin-cert/export' //证书导出
export const kUrlCertQueryPersonInfo = adminUrl + '/admin-cert/queryPersonInfo' //根据场景查询用户分页信息

//证书路径阶段配置
export const kUrlCertStagePageList = adminUrl + '/admin-certStage/pageList' //证书路径阶段配置列表
export const kUrlCertStageAdd = adminUrl + '/admin-certStage/add' //证书路径阶段配置新增
export const kUrlCertStageUpdate = adminUrl + '/admin-certStage/update'  //证书路径阶段配置更新
export const kUrlCertStageDelete = adminUrl + '/admin-certStage/delete' //证书路径阶段配置删除
export const kUrlCertStageGetInfo = adminUrl + '/admin-certStage/getInfo' //证书路径阶段配置单个
export const kUrlCertStageList = adminUrl + '/admin-certStage/list' //证书路径阶段配置导出

//个人证书
export const kUrlCertRecordController = adminUrl + '/admin-trainCertRecordController/getPageList' //证书列表
export const kUrlCertRecordAdd = adminUrl + '/admin-trainCertRecordController/add' //证书新增
export const kUrlCertRecordUpdate = adminUrl + '/admin-trainCertRecordController/upd'  //证书更新
export const kUrlCertRecordExport = adminUrl + '/admin-trainCertRecordController/export'  //证书导出
export const kUrlCertRecordImportFile = adminUrl + '/admin-trainCertRecordController/importFile'  //证书导入
export const kUrlCertRecordUpdateState = adminUrl + '/admin-trainCertRecordController/updateState'  //证书启用 禁用
export const kUrlCertRecordExportByUserIdentity = adminUrl + '/admin-trainCertRecordController/exportByUserIdentity'  //证书按任职导出
export const kUrlCertRecordExportDetailFile = adminUrl + '/admin-trainCertRecordController/exportCertRecordDetailFile'  //证书导出File
export const kUrlCertRecordExportDetailByIdentityFile = adminUrl + '/admin-trainCertRecordController/exportCertRecordDetailByIdentityFile'  //证书按任职导出File

//证书邮寄
export const kUrlCertPostConfirm = adminUrl + '/admin-certPostApply/batchCertPost'  //批量证书邮寄确认

//个人证书申请管理
export const kUrlCertApplyListByPage = adminUrl + '/admin-trainCertApplyController/getPageList' //个人证书申请列表
export const kUrlBatchUpdateCertApply = adminUrl + '/admin-trainCertApplyController/batchCheck' //个人证书申请批量审核
export const kUrlGetCertApplyInfoById = adminUrl + '/admin-trainCertApplyController/getCertApplyInfoById' //获取个人证书申请信息
export const kUrlCertApplyCheck = adminUrl + '/admin-trainCertApplyController/check' //审核操作接口
export const kUrlCertApplyBatchCheck = adminUrl + '/admin-trainCertApplyController/batchCheck' //批量审核操作接口

//证书挂靠
export const kUrlCertLinkRelationList = adminUrl + '/admin-certLinkRelationController/getPageList' //证书挂靠列表
export const kUrlCertLinkUserIdentityList = adminUrl + '/admin-certLinkUserIdentityContrller/getCertLinkUserIdentityList' //证书所属组织列表
export const kUrlCertLinkRelationUpdateOrg = adminUrl + '/admin-certLinkRelationController/updateOrg' //证书挂靠修改所属组织
export const kUrlCertLinkRelationUpdateLinkState = adminUrl + '/admin-certLinkRelationController/updateLinkState' //取消确认证书
export const kUrlCertLinkRelationGetList = adminUrl + '/admin-certLinkRelationController/getList' //取消确认证书
export const kUrlCertLinkRelationImportFile = adminUrl + '/admin-certLinkRelationController/importFile' //导入数据
export const kUrlCertLinkRelationGetOrgIdList = adminUrl + '/admin-certLinkRelationController/getOrgIdList' //导入数据

/**
 * 应用服务管理
 */
//应用服务
export const kUrlApplicationManagePageList = adminUrl + '/admin-applicationManage/listByPage'
export const kUrlApplicationManageList = adminUrl + '/admin-applicationManage/list'
export const kUrlApplicationManageEnable = adminUrl + '/admin-applicationManage/enable'
export const kUrlApplicationManageAdd = adminUrl + '/admin-applicationManage/add'
export const kUrlApplicationManageUpdate = adminUrl + '/admin-applicationManage/update'

//栏目应用
export const kUrlApplicationColumnPageList = adminUrl + '/admin-applicationColumn/listByPage'
export const kUrlApplicationColumnList = adminUrl + '/admin-applicationColumn/list'
export const kUrlApplicationColumnEnable = adminUrl + '/admin-applicationColumn/enable'
export const kUrlApplicationColumnAdd = adminUrl + '/admin-applicationColumn/add'
export const kUrlApplicationColumnUpdate = adminUrl + '/admin-applicationColumn/update'
export const kUrlApplicationColumnVisitPageList = adminUrl + '/admin-applicationColumn/visitPageList'
export const kUrlApplicationColumnVisitList = adminUrl + '/admin-applicationColumn/visitList'
export const kUrlApplicationColumnChoosePageList = adminUrl + '/admin-applicationColumn/choosePageList'
export const kUrlApplicationColumnChooseList = adminUrl + '/admin-applicationColumn/chooseList'

/**
 * 社区管理
 */
//话题管理
export const kUrlTopicFollowListByPage = adminUrl + '/admin-topicFollow/pageList'
export const kUrlTopicFollowExport = adminUrl + '/admin-topicFollow/getList'
export const kUrlTopicListByPage = adminUrl + '/admin-topic/listByPage'
export const kUrlTopicBaseListByPage = adminUrl + '/admin-topic/baseListByPage'
export const kUrlTopicBasePageByDataPermission = adminUrl + '/admin-topic/baseListPageByDataPermission'
export const kUrlCreateTopic = adminUrl + '/admin-topic/createTopic'
export const kUrlUpdateTopic = adminUrl + '/admin-topic/updateTopic'
export const kUrlEnableTopic = adminUrl + '/admin-topic/enable'
export const kUrlTopicTopping = adminUrl + '/admin-topic/topicTopping'
export const kUrlExportTopic = adminUrl + '/admin-topic/export'
export const kUrlTopicLook = adminUrl + '/admin-topic/findById'

//帖子管理
export const kUrlInvitationPageList = adminUrl + '/admin-invitation/listByPage'
export const kUrlInvitationList = adminUrl + '/admin-invitation/list'
export const kUrlInvitationAdd = adminUrl + '/admin-invitation/add'
export const kUrlInvitationDelete = adminUrl + '/admin-invitation/delete'
export const kUrlInvitationEnable = adminUrl + '/admin-invitation/enable'

//活动管理
export const kUrlActivityPageList = adminUrl + '/admin-activity/listByPage'
export const kUrlActivityList = adminUrl + '/admin-activity/list'
export const kUrlActivityAdd = adminUrl + '/admin-activity/add'
export const kUrlActivityUpdate = adminUrl + '/admin-activity/update'
export const kUrlActivityEnable = adminUrl + '/admin-activity/enable'
export const kUrlActivityLook = adminUrl + '/admin-activity/findById'
export const kUrlActivityParticipateExport = adminUrl + '/admin-activity/participateExport'
//活动环节管理
export const kUrlActivityPartPageList = adminUrl + '/admin-activityPart/listByPage'
export const kUrlActivityPartList = adminUrl + '/admin-activityPart/list'
export const kUrlActivityPartAdd = adminUrl + '/admin-activityPart/add'
export const kUrlActivityPartUpdate = adminUrl + '/admin-activityPart/update'
export const kUrlActivityPartEnable = adminUrl + '/admin-activityPart/enable'
export const kUrlActivityPartLook = adminUrl + '/admin-activityPart/findById'
export const kUrlActivityPartParticipateExport = adminUrl + '/admin-activityPart/participateExport'

//活动话题管理
export const kUrlActivityTopicList = adminUrl + '/admin-activityTopic/list'
export const kUrlCreateActivityTopic = adminUrl + '/admin-activityTopic/create'
export const kUrlActivityTopicEnable = adminUrl + '/admin-activityTopic/enable'
//活动通知管理
export const kUrlActivityMessagePageList = adminUrl + '/admin-activityMessage/listByPage'
export const kUrlActivityMessageAdd = adminUrl + '/admin-activityMessage/add'
export const kUrlActivityMessageUpdate = adminUrl + '/admin-activityMessage/update'
export const kUrlActivityMessageEnable = adminUrl + '/admin-activityMessage/enable'
export const kUrlActivityMessageLook = adminUrl + '/admin-activityMessage/findById'


//内容管理
export const kUrlGetContentInfoList = adminUrl + '/admin-content/listByPage'
export const kUrlContentAdd = adminUrl + '/admin-content/add'
export const kUrlContentUpd = adminUrl + '/admin-content/upd'
export const kUrlContentDetailInfo = adminUrl + '/admin-content/detailInfo'
export const kUrlContentRecordList = adminUrl + '/admin-content/recordExport'
export const kUrlLearningMaterialRecordExport = adminUrl + '/admin-content/LearningMaterialRecordExport'
export const kUrlContentRecordPageList = adminUrl + '/admin-content/recordListByPage'
export const kUrlContentEnable = adminUrl + '/admin-content/enable'
export const kUrlContentChangeTop = adminUrl + '/admin-content/changeTop'
export const kUrlContentExport = adminUrl + '/admin-content/export'
export const kUrlContentDelete = adminUrl + '/admin-content/delete'
export const kUrlAddContentRecord = adminUrl + '/admin-content/addContentRecord' //阅读/下载计数

//内容标签管理

//分类管理接口
export const kUrlImportLabelInfo = adminUrl + '/admin-label/import'; //分类导入
export const kUrlExportLabelInfo = adminUrl + '/admin-label/export' //分类导出
export const kUrlLabelListByPage = adminUrl + '/admin-label/listByPage' //获取page对象
export const kUrlLabelNodeList = adminUrl + '/admin-categoryInfo/nodeList' //获取ListTree对象
export const kUrlAddLabel = adminUrl + '/admin-label/add' //添加分类
export const kUrlUpdLabel = adminUrl + '/admin-label/upd' //修改分类
export const kUrlDelLabel = adminUrl + '/admin-label/del' //删除分类
export const kUrlEnableLabel = adminUrl + '/admin-label/enable' //启用禁用
export const kUrlShortVideoLabelListByPage = adminUrl + '/admin-label/shortVideoLabelPageList'
//评论接口
export const kUrlCommentPageList = adminUrl + '/admin-comment/listByPage'; //获取page对象
export const kUrlCommentChangeTop = adminUrl + '/admin-comment/changeTop'; //改变置顶状态
export const kUrlCommentChangeScreen = adminUrl + '/admin-comment/changeScreen'; //改变屏蔽状态
export const kUrlCommentChangeScreenBatch = adminUrl + '/admin-comment/changeScreenBatch'
export const kUrlCommentExport = adminUrl + '/admin-comment/export'; //导出
export const kUrlCommentMarkDetailPageList = adminUrl + '/admin-comment/commentMarkDetailPageList'; //获取课程评价page对象

export const kUrlShortVideoCommentPageList = adminUrl + '/admin-comment/shortVideoCommentPageList'; //获取短视频评论page对象
export const kUrlShortVideoCommentList = adminUrl + '/admin-comment/shortVideoCommentList'; //获取短视频评论

//点赞接口
export const kUrlOperateRecordPageList = adminUrl + '/admin-operateRecord/pageList';//点赞列表
export const kUrlOperateRecordAdd = adminUrl + '/admin-operateRecord/add'//添加点赞
export const kUrlOperateRecordExport = adminUrl + '/admin-operateRecord/export'//导出
export const kUrlOperateRecordUserPageList = adminUrl + '/admin-operateRecord/operateRecordUserPageList'
export const kUrlOperateRecordUserList = adminUrl + '/admin-operateRecord/operateRecordUserList'

export const kUrlShortVideoOperateRecordPageList = adminUrl + '/admin-operateRecord/shortVideoOperatePageList';//获取短视频点赞
export const kUrlShortVideoOperateRecordList = adminUrl + '/admin-operateRecord/shortVideoOperateList';//获取短视频点赞
//系列化接口
export const kUrlSeriesPageList = adminUrl + '/admin-seriesController/getPageList';
export const kUrlSeriesAdd = adminUrl + '/admin-seriesController/add';
export const kUrlSeriesUpd = adminUrl + '/admin-seriesController/upd';
export const kUrlGetSeriesList = adminUrl + '/admin-seriesController/export';
export const kUrlGetSeriesInfo = adminUrl + '/admin-seriesController/getOneById';
export const kUrlUpdateState = adminUrl + '/admin-seriesController/updateState';
export const kUrlExportFollowRecord = adminUrl + '/admin-seriesController/exportFollowRecord';
export const kUrlSeriesImport = adminUrl + '/admin-seriesController/import';
export const kUrlExportSeriesStudyDetail = adminUrl + '/admin-seriesController/exportSeriesStudyDetail';
export const kUrlExportSeriesStudyReport = adminUrl + '/admin-seriesController/exportSeriesStudyReport';


//推荐管理
export const kUrlFeaturedListByPage = adminUrl + '/admin-featured/listByPage'
export const kUrlCreateFeatured = adminUrl + '/admin-featured/create'
export const kUrlUpdateFeatured = adminUrl + '/admin-featured/update'
export const kUrlFindFeatured = adminUrl + '/admin-featured/findFeatured'
export const kUrlUpdateFeaturedState = adminUrl + '/admin-featured/updateState'
export const kUrlExportFeatured = adminUrl + '/admin-featured/export'
export const kUrlFeaturedList = adminUrl + '/admin-featured/featuredList'

export const kUrlSeriesProgramAdd = adminUrl + '/admin-seriesProgramRelationController/add';
export const kUrlSeriesProgramUpd = adminUrl + '/admin-seriesProgramRelationController/upd';
export const kUrlGetSeriesProgramPageList = adminUrl + '/admin-seriesProgramRelationController/getPageList';
export const kUrlExportSeriesProgram = adminUrl + '/admin-seriesProgramRelationController/export';

//报表 统计
export const kUrlGetDealerRuleListByPage = adminUrl + '/admin-dealerRule/getPageList' //考核经销商列表
export const kUrlDealerRuleImportFile = adminUrl + '/admin-dealerRule/importFile';//导入考核经销商

export const kUrlGetScaleRuleList = adminUrl + '/admin-scaleRule/getList' //经销商规模规则列表
export const kUrlAddScaleRule = adminUrl + '/admin-scaleRule/add' //新增经销商规模规则
export const kUrlDeleteScaleRule = adminUrl + '/admin-scaleRule/delete' //删除经销商规模规则
export const kUrlUpdateScaleRule = adminUrl + '/admin-scaleRule/upd' //编辑经销商规模规则
export const kUrlImportPositionRule = adminUrl + '/admin-positionRule/importFile' //导入岗位组规则
export const kUrlGetPositionRuleList = adminUrl + '/admin-positionRule/getList' //获取岗位组规则

//规则服务
export const kUrlAddRuleConfigure = adminUrl + '/admin-rule-configure/add' //新增规则服务配置
export const kUrlUpdRuleConfigure = adminUrl + '/admin-rule-configure/upd' //修改规则服务配置
export const kUrlEnableRuleConfigure = adminUrl + '/admin-rule-configure/enable' //启用禁用规则服务配置
export const kUrlGetRuleConfigureList = adminUrl + '/admin-rule-configure/listByPage' //规则服务配置列表
export const kUrlGetRuleConfigureEditInfo = adminUrl + '/admin-rule-configure/editInfo' //规则服务详情
export const kUrlGetRuleConfigureRecordInfo = adminUrl + '/admin-rule-configure/recordInfo' //规则记录详情

//科目管理
export const kUrlSubjectGetPageList = adminUrl + '/admin-subject/getPageList'
export const kUrlSubjectAdd = adminUrl + '/admin-subject/add'
export const kUrlSubjectUpd = adminUrl + '/admin-subject/upd'
export const kUrlSubjectDel = adminUrl + '/admin-subject/del'
export const kUrlSubjectUpdateState = adminUrl + '/admin-subject/updateState'
export const kUrlSubjectGetInfoById = adminUrl + '/admin-subject/getInfoById'
export const kUrlSubjectQueryPersonInfo = adminUrl + '/admin-subject/queryPersonInfo'
export const kUrlSubjectQueryQueryOrgInfo = adminUrl + '/admin-subject/queryOrgInfo'

/**作业管理 */
export const kUrlHomeworkListByPage = adminUrl + '/admin-homework/getPageList';//列表查询
export const kUrlAddHomework = adminUrl + '/admin-homework/add';//新增作业
export const kUrlUpdateHomework = adminUrl + '/admin-homework/upd';//修改作业
export const kUrlDeleteHomework = adminUrl + '/admin-homework/delete';//修改删除
export const kUrlGetHomeworkInfo = adminUrl + '/admin-homework/selectOneById';//获取作业信息
export const kUrlsetHomeworkState = adminUrl + '/admin-homework/updateState';//修改作业状态
export const kUrlExportHomework = adminUrl + '/admin-homework/export';//作业列表导出
//科目学分记录管理
export const kUrlSubjectCreditRecordSubjectCreditDealerRecordPage = adminUrl + '/admin-subjectCreditRecord/subjectCreditDealerRecordPage'
export const kUrlSubjectCreditRecordUpd = adminUrl + '/admin-subjectCreditRecord/upd'
export const kUrlSubjectCreditRecordAdd = adminUrl + '/admin-subjectCreditRecord/add'
export const kUrlSubjectCreditRecordGetDealerById = adminUrl + '/admin-subjectCreditRecord/getDealerById'
export const kUrlSubjectCreditRecordUpdateState = adminUrl + '/admin-subjectCreditRecord/updateState'
export const kUrlSubjectCreditRecordImport = adminUrl + '/admin-subjectCreditRecord/importSubjectCreditFile'
export const kUrlSubjectCreditPersonRecordExport = adminUrl + '/admin-subjectCreditRecord/subjectCreditPersonRecordExport'
export const kUrlSubjectCreditDealerRecordExport = adminUrl + '/admin-subjectCreditRecord/subjectCreditDealerRecordList'

//作业记录
export const kUrlHomeworkRecordControllerListByPage = adminUrl + '/admin-homeworkRecordController/getPageList';//作业记录  列表查询
export const kUrlHomeworkRecordControllerReviewListByPage = adminUrl + '/admin-homeworkRecordController/getReviewPageList';//作业批阅  列表查询
export const kUrlHomeworkRecordControllerExport = adminUrl + '/admin-homeworkRecordController/export';//作业记录  导出
export const kUrlHomeworkRecordControllerExportReview = adminUrl + '/admin-homeworkRecordController/exportReview';//批阅作业  导出
export const kUrlHomeworkRecordControllerReviewCheck = adminUrl + '/admin-homeworkRecordController/reviewCheck';//批阅前校验//成功则可以，失败则不能
export const kUrlHomeworkRecordControllerReview = adminUrl + '/admin-homeworkRecordController/review';//提交批改作业操作
export const kUrlHomeworkRecordControllerReviewResult = adminUrl + '/admin-homeworkRecordController/reviewResult';//提交批改结果修改
export const kUrlHomeworkRecordControllerReviewResultNext = adminUrl + '/admin-homeworkRecordController/reviewResultNext';//提交批改结果并且获取下一个
export const kUrlHomeworkRecordControllerGetInfoById = adminUrl + '/admin-homeworkRecordController/getInfoById';//获取单个
export const kUrlHomeworkRecordControllerGetResultInfoById = adminUrl + '/admin-homeworkRecordController/getResultInfoById';//获取单个
export const kUrlHomeworkRecordControllerBatchAudit = adminUrl + '/admin-homeworkRecordController/batchAudit';//批量审核

//任务管理
export const kUrlTaskInfoListByPage = adminUrl + '/admin-task/listByPage';//任务管理列表接口
export const kUrlTaskInfoEditInfo = adminUrl + '/admin-task/editInfo';//任务管理详细信息
export const kUrlTaskInfoAdd = adminUrl + '/admin-task/add';//任务管理新增
export const kUrlTaskInfoUpd = adminUrl + '/admin-task/upd';//任务管理修改
export const kUrlTaskInfoEnable = adminUrl + '/admin-task/enable';//任务开启关闭
export const kUrlTaskInfoList = adminUrl + '/admin-task/taskList';

//任务记录

export const kUrlTaskRecordListByPage = adminUrl + '/admin-taskRecord/listByPage';//任务记录列表接口
export const kUrlTaskRecordListExport = adminUrl + '/admin-taskRecord/export';//任务记录列表导出

//第三方课件
export const kUrlCoursewarePageList = adminUrl + '/admin-coursewareInfo/pageList'
export const kUrlCoursewareAdd = adminUrl + '/admin-coursewareInfo/add'
export const kUrlCoursewareUpd = adminUrl + '/admin-coursewareInfo/upd'
export const kUrlCoursewareSelectOneById = adminUrl + '/admin-coursewareInfo/selectOneById'


//公共配置管理
export const kUrlCommonConfigPage = baseUrl + '/base-config/pageList';//公共配置管理列表
export const kUrlCommonConfigAdd = baseUrl + '/base-config/add';//新增公共配置
export const kUrlCommonConfigUpdate = baseUrl + '/base-config/update';//修改公共配置
export const kUrlCommonConfigUpdateState = baseUrl + '/base-config/updateState';//修改公共配置状态
export const kUrlCommonConfigBatchDelete = baseUrl + '/base-config/batchDelete';//删除公共配置
export const kUrlCommonConfigExport = baseUrl + '/base-config/export';//公共配置信息导出

//用户记录日志
export const kUrlAuthUserLogPage = baseUrl + '/base-AuthUserLog/pageList';//用户记录日志列表

export const kUrlUserInfo = baseUrl + '/base-personCenter/findPersonInfo'//获取用户详情信息

export const kUrlAdminDataPermList = adminUrl + '/admin-data-perm/listByPage'//获取受众组列表

// 受众组
export const kUrlAdminDataPermGroupList = adminUrl + '/admin-data-perm-group/listByPage'//获取受众组列表
export const kUrlAdminDataPermGroupUpd = adminUrl + '/admin-data-perm-group/upd'
export const kUrlAdminDataPermGroupAdd = adminUrl + '/admin-data-perm-group/add'
export const kUrlAdminDataPermGroupEditInfo = adminUrl + '/admin-data-perm-group/editInfo'

// 管理权限
export const kUrlAdminDataPermQueryAuthInfo = adminUrl + '/admin-data-perm/queryAuthInfo'
export const kUrlAdminDataPermSave = adminUrl + '/admin-data-perm/save'

// 报表
export const kUrlExamReportList = adminUrl + '/admin-examReport/getPageList' //考试成绩导出--查询
export const kUrlExamReportExport = adminUrl + '/admin-examReport/export' //考试成绩导出--导出
export const kUrlExamReportListOrg = adminUrl + '/admin-examReport/getPageListOrg' //考试+组织维度--查询
export const kUrlExamReportExportOrg = adminUrl + '/admin-examReport/exportOrg' //考试+组织维度--导出
export const kUrlExamReportListOrgPosition = adminUrl + '/admin-examReport/getPageListOrgPosition' //考试+岗位+经销商维度--查询
export const kUrlExamReportExportOrgPosition = adminUrl + '/admin-examReport/exportOrgPosition' //考试+岗位+经销商维度--导出

export const kUrlProgramReportList = adminUrl + '/admin-programReport/getPageList' //在线课程完成情况--查询
export const kUrlProgramReportExport = adminUrl + '/admin-programReport/export' //在线课程完成情况--导出
export const kUrlProgramReportListProgramOrg = adminUrl + '/admin-programReport/getPageListProgramOrg' //在线课程 课程+组织维度--查询
export const kUrlProgramReportExportProgramOrg = adminUrl + '/admin-programReport/exportProgramOrg' //在线课程 课程+组织维度--导出
export const kUrlProgramReportListProgram = adminUrl + '/admin-programReport/getPageListProgram' //在线课程 课程维度--查询
export const kUrlProgramReportExportProgram = adminUrl + '/admin-programReport/exportProgram' //在线课程 课程维度--导出

export const kUrlOfflineProgramReportList = adminUrl + '/admin-offlineProgramReport/getPageList' //线下培训学员统计--查询
export const kUrlOfflineProgramReportExport = adminUrl + '/admin-offlineProgramReport/export' //线下培训学员统计--导出
export const kUrlOfflineProgramReportListAuth = adminUrl + '/admin-offlineProgramReport/getPageListAuth' //线下培训及认证情况统计--查询
export const kUrlOfflineProgramReportExportAuth = adminUrl + '/admin-offlineProgramReport/exportAuth' //线下培训及认证情况统计--导出
export const kUrlOfflineProgramReportListProgramOrg = adminUrl + '/admin-offlineProgramReport/getPageListProgramOrg' //线下培训 课程+组织维度 --查询
export const kUrlOfflineProgramReportExportProgramOrg = adminUrl + '/admin-offlineProgramReport/exportProgramOrg' //线下培训 课程+组织维度--导出
export const kUrlOfflineProgramReportListProgram = adminUrl + '/admin-offlineProgramReport/getPageListProgram' //线下培训 课程维度 --查询
export const kUrlOfflineProgramReportExportProgram = adminUrl + '/admin-offlineProgramReport/exportProgram' //线下培训 课程维度 --导出

export const kUrlCertReportListStudent = adminUrl + '/admin-certReport/getPageListStudent' //人员证书获得明细--查询
export const kUrlCertReportExportStudent = adminUrl + '/admin-certReport/exportStudent' //人员证书获得明细--导出
export const kUrlCertReportListOrg = adminUrl + '/admin-certReport/getPageListOrg' //组织认证统计--查询
export const kUrlCertReportExportOrg = adminUrl + '/admin-certReport/exportOrg' //组织认证统计--导出

export const kUrlPathReportListStudentDetail = adminUrl + '/admin-pathReport/getPageListStudentDetail' //个人任务路径明细--查询
export const kUrlPathReportExportStudentDetail = adminUrl + '/admin-pathReport/exportStudentDetail' //个人任务路径明细--导出
export const kUrlPathReportListStudentComplete = adminUrl + '/admin-pathReport/getPageListStudentComplete' //个人任务路径完成情况--查询
export const kUrlPathReportExportStudentComplete = adminUrl + '/admin-pathReport/exportStudentComplete' //个人任务路径完成情况--导出
export const kUrlPathReportListOrg = adminUrl + '/admin-pathReport/getPageListOrg' //组织路径完成情况--查询
export const kUrlPathReportExportOrg = adminUrl + '/admin-pathReport/exportOrg' //组织路径完成情况--导出
export const kUrlPathReportListTaskDetail = adminUrl + '/admin-pathReport/getPageListTaskDetail' //个人任务路径明细--查询
export const kUrlPathReportExportTaskDetail = adminUrl + '/admin-pathReport/exportTaskStudentDetail' //个人任务路径明细--导出
export const kUrlPathReportListScoreComplete = adminUrl + '/admin-pathReport/getPageListScoreDetail' //个人任务路径完成情况--查询
export const kUrlPathReportExportScoreComplete = adminUrl + '/admin-pathReport/exportScoreStudentDetail' //个人任务路径完成情况--导出
//学员维度
export const kUrlDimStudentReportPageList = adminUrl + '/admin-dimStudentReport/listByPage' //个人任务路径完成情况--查询
export const kUrlDimStudentReportList = adminUrl + '/admin-dimStudentReport/list' //个人任务路径完成情况--导出

//参训统计报表接口
export const kUrlDealerTrainReportList = adminUrl + '/admin-dealerTrainReport/dealerTrainReportList' //经销商参训报告查询
export const kUrlDealerTrainReportPage = adminUrl + '/admin-dealerTrainReport/dealerTrainReportPage' //经销商参训报告分页列表查询

export const kUrlPositionTrainReportList = adminUrl + '/admin-positionTrainReport/positionTrainReportList' //经销商参训报告查询
export const kUrlPositionTrainReportPage = adminUrl + '/admin-positionTrainReport/positionTrainReportPage' //经销商参训报告分页列表查询

// 前置条件
export const kUrlBeforeConditionSave = adminUrl + '/admin-beforeCondition/save' // 保存
export const kUrlBeforeConditionDelete = adminUrl + '/admin-beforeCondition/del' // 删除
export const kUrlBeforeConditionDetailInfo = adminUrl + '/admin-beforeCondition/getDetailInfo' // 列表

// 数据分析报表 (接口待后续补充完善)
export const kUrlGetReportConfigPageList = adminUrl + '/admin-reportConfig/pageList' // 列表
export const kUrlReportConfigAdd = adminUrl + '/admin-reportConfig/add' // 新增
export const kUrlReportConfigUpd = adminUrl + '/admin-reportConfig/upd' // 编辑
export const kUrlExportReportConfigList = adminUrl + '/admin-reportConfig/list' // 导出
export const kUrlSelectOneByIdReportConfig = adminUrl + '/admin-reportConfig/selectOneById' // 单个查询
export const kUrlSelectOneDetailByIdReportConfig = adminUrl + '/admin-reportConfig/selectOneDetailById' // 单个查询
export const kUrlPageDetailListReportConfig = adminUrl + '/admin-reportConfig/pageDetailList' // 报表详情列表查询
export const kUrlDetailListReportConfig = adminUrl + '/admin-reportConfig/detailList' // 报表详情列表查询导出


// 数据分析配置表
export const kUrlGetTableConfigPageList = adminUrl + '/admin-tableConfig/getPageList' // 分页列表
export const kUrlGetTableConfigList = adminUrl + '/admin-tableConfig/getList' // 列表
export const kUrlTableConfigAdd = adminUrl + '/admin-tableConfig/add' // 新增
export const kUrlTableConfigUpd = adminUrl + '/admin-tableConfig/upd' // 编辑

// 数据分析 表字段管理
export const kUrlGetTableFieldPageAllList = adminUrl + '/admin-tableField/getPageAllList' // 列表
export const kUrlGetTableFieldList = adminUrl + '/admin-tableField/getList' // 列表
export const kUrlTableFieldAdd = adminUrl + '/admin-tableField/add' // 新增
export const kUrlTableFieldUpd = adminUrl + '/admin-tableField/upd' // 编辑

//消息通知记录
export const kUrlMessageNoticeRecordPageList = adminUrl + '/admin-messageNoticeRecord/listByPage'
export const kUrlGetSceneByTypeList = adminUrl + '/admin-messageNoticeRecord/getSceneByType'
export const kUrlMessageNoticeRecordDetailPageList = adminUrl + '/admin-messageNoticeRecord/recordByPage'
export const kUrlMessageNoticeRecordDetailPic = adminUrl + '/admin-messageNoticeRecord/recordPic'

export const kUrlNoticeSendNotice = adminUrl + '/admin-notice/sendNotice';


export const kUrlGenerateCallBackUrl = baseUrl + '/auth/generateCallBackUrl';
export const kUrlJumpUrl = baseUrl + '/auth/jumpUrl';
export const  kUrlGetLoginInfo = baseUrl + '/auth/getLoginInfo';

export const kUrlBizDataPageList = adminUrl + '/admin-bizData/pageList'
export const kUrlBizDataAdd = adminUrl + '/admin-bizData/add'
export const kUrlCoprListByPage = baseUrl + '/base-corp/listByPage';
export const kUrlAddThirdCopr = baseUrl + '/base-corp/addCorp';
export const kUrlUpdateThirdCopr = baseUrl + '/base-corp/updCorp';
export const kUrlDeleteThirdCopr = baseUrl + '/base-corp/deleteCorp';
export const kUrlCoprList = baseUrl + '/base-corp/list';

export const kUrlCorpUserListByPage = baseUrl + '/base-corpUser/listByPage';
export const kUrlCorpUserList = baseUrl + '/base-corpUser/list';
export const kUrlCorpUserSave = baseUrl + '/base-corpUser/save';
export const kUrlCorpUserImport = baseUrl + '/base-corpUser/importFile'


export const kUrlAppListByPage = baseUrl + '/base-app/listByPage';
export const kUrlAddThirdApp = baseUrl + '/base-app/addApp';
export const kUrlUpdateThirdApp = baseUrl + '/base-app/updApp';
export const kUrlDeleteThirdApp = baseUrl + '/base-app/deleteApp';
export const kUrlGetLabelInfoThirdApp = baseUrl + '/base-app/getLabelInfo';

export const kUrlWhitelistAuthInfo = adminUrl + '/admin-data-perm/queryUserAuthInfo'
export const kUrlWhitelistSave = adminUrl + '/admin-data-perm/saveUserAuth'
export const kUrlWhitelistPersonInfo = adminUrl + '/admin-data-perm/queryScopePersonInfo'

export const kUrlCleExamPageList = adminUrl + '/admin-cleExam/pageList'
export const kUrlCleExamList = adminUrl + '/admin-cleExam/list'
export const kUrlCleExamSave = adminUrl + '/admin-cleExam/save'
export const kUrlCleExamUpdateState = adminUrl + '/admin-cleExam/updateState'
export const kUrlCleExamStudentsAnswers =  adminUrl + '/admin-cleExam/exportStudentsAnswers'

export const kUrlCertOrgAuthPageList = adminUrl + '/admin-certOrgAuth/pageList'
export const kUrlCertOrgAuthListExport = adminUrl + '/admin-certOrgAuth/list'
export const kUrlCertCategoryConfigPageList = adminUrl + '/admin-certCategoryConfig/pageList'
export const kUrlCertCategoryConfigAdd = adminUrl + '/admin-certCategoryConfig/add'
export const kUrlCertCategoryConfigUpdate = adminUrl + '/admin-certCategoryConfig/update'
export const kUrlCertCategoryConfigDelete = adminUrl + '/admin-certCategoryConfig/delete'

export const kUrlShortVideoPageList = adminUrl + '/admin-shortVideo/pageList'
export const kUrlShortVideoList = adminUrl + '/admin-shortVideo/list'
export const kUrlShortVideoInfo = adminUrl + '/admin-shortVideo/findById'
export const kUrlShortVideoAdd = adminUrl + '/admin-shortVideo/add'
export const kUrlShortVideoUpdateSet = adminUrl + '/admin-shortVideo/updateSet'
export const kUrlShortVideoRecordPageList = adminUrl + '/admin-shortVideo/operatePageList'
export const kUrlShortVideoRecordList = adminUrl + '/admin-shortVideo/operateList'
export const kUrlShortVideoUpdateState = adminUrl + '/admin-shortVideo/updateState'
export const kUrlShortVideoDelete = adminUrl + '/admin-shortVideo/delete'


export const kUrlShortVideoScreenPageList = adminUrl + '/admin-shortVideoScreen/pageList'
export const kUrlShortVideoScreenList = adminUrl + '/admin-shortVideoScreen/list'
export const kUrlShortVideoScreenRecordPageList = adminUrl + '/admin-shortVideoScreen/recordPageList'
export const kUrlShortVideoScreenRecordList = adminUrl + '/admin-shortVideoScreen/recordList'
export const kUrlShortVideoScreenToDeal = adminUrl + '/admin-shortVideoScreen/toDeal'
export const kUrlShortVideoScreenLook = adminUrl + '/admin-shortVideoScreen/findById'


export const kUrlShortVideoPersonRelationPageList = adminUrl + '/admin-shortVideoPersonRelation/pageList'
export const kUrlShortVideoPersonRelationList = adminUrl + '/admin-shortVideoPersonRelation/list'

export const kUrlShortVideoMessagePageList = adminUrl + '/admin-shortVideoMessage/pageList'
export const kUrlShortVideoMessageList = adminUrl + '/admin-shortVideoMessage/list'

//融入辅导 - 提醒
export const kUrlIntegrationCounselingListRemind = adminUrl + '/admin-fuseTutor/remind'
export const kUrlIntegrationCounselingProcessRemind = adminUrl + '/admin-fuseTutor/remindById'
//融入辅导 - 配置
export const kUrlPreAuditPageList = adminUrl + '/admin-auditBase/pageList'
export const kUrlPreAuditList = adminUrl + '/admin-auditBase/list'
export const kUrlPreAuditAdd = adminUrl + '/admin-auditBase/add'
export const kUrlPreAuditImport = adminUrl + '/admin-icVersion/importFile'
export const kUrlPreAuditDownloadList = adminUrl + '/admin-icVersion/pageList'
export const kUrlPersonnelTrainingPageList = adminUrl + '/admin-training/pageList'
export const kUrlPersonnelTrainingList = adminUrl + '/admin-training/list'
export const kUrlPersonnelTrainingAdd = adminUrl + '/admin-training/add'
export const kUrlPersonnelTrainingUpd = adminUrl + '/admin-training/upd'
export const kUrlPersonnelTrainingEnable = adminUrl + '/admin-training/setState'
export const kUrlKPIPageList = adminUrl + '/admin-kpi/pageList'
export const kUrlKPIList = adminUrl + '/admin-kpi/list'
export const kUrlKPIAdd = adminUrl + '/admin-kpi/add'
export const kUrlKPIEnable = adminUrl + '/admin-kpi/setState'

export const kUrlSatisfactionPageList = adminUrl + '/admin-satisfaction/getPageList'
export const kUrlSatisfactionList = adminUrl + '/admin-satisfaction/getList'
export const kUrlSatisfactionAdd = adminUrl + '/admin-satisfaction/add'
export const kUrlSatisfactionEnable = adminUrl + '/admin-satisfaction/updateState'

//融入辅导-满意度评估Re
export const kUrlTrackSatisfactionPageList = adminUrl + '/admin-trackSatisfactionMonth/getTrackSatisfactionMonthList'
export const kUrlTrackCheckSatisfaction = adminUrl + '/admin-trackSatisfactionMonth/checkSatisfaction'
export const kUrlTrackInputTrackSatisfactionMonth = adminUrl + '/admin-trackSatisfactionMonth/inputTrackSatisfactionMonth'
export const kUrlTrackSatisfactionMonthUpdate = adminUrl + '/admin-trackSatisfactionMonth/update'
export const kUrlTrackSatisfactionMonthDelete = adminUrl + '/admin-trackSatisfactionMonth/delete'

//新能源人员面试
export const kUrlResumeInfoPageList = baseUrl + '/base-resume/queryResumeInfoPageList'
export const kUrlResumeInfoList = baseUrl + '/base-resume/queryResumeInfoList'
export const kUrlResumeUpdate = baseUrl + '/base-resume/update'
export const kUrlPersonalityChecklist = adminUrl + '/admin-mbtiCharacterContrast/getList'
export const kUrlInterviewQuestionPageList = adminUrl + '/admin-mbtiExam/listByPage'
export const kUrlInterviewQuestionList = adminUrl + '/admin-mbtiExam/getList'
export const kUrlInterviewQuestionImport = adminUrl + '/admin-mbtiExam/importFile'
export const kUrlExportResumeList = baseUrl + '/base-resume/queryExportResumeList'
export const kUrlExportMbtiList = baseUrl + '/base-resume/queryExportMbtiList'
export const kUrlResumeExportPDF = baseUrl + '/base-resume/getResumeInfoPersonReport'
export const kUrlResumeInfoNeedAgainPageList = baseUrl + '/base-resume/queryResumeInfoNeedAgainPageList'
export const kUrlResumeApply = baseUrl + '/base-resume/applyResume'


//融入辅导
export const kUrlIntegrationCounselingPageList = adminUrl + '/admin-fuseTutor/pageList'
export const kUrlIntegrationCounselingList = adminUrl + '/admin-fuseTutor/list'
export const kUrlIntegrationCounselingAdd = adminUrl + '/admin-fuseTutor/add'
export const kUrlIntegrationCounselingUpd = adminUrl + '/admin-fuseTutor/upd'
export const kUrlIntegrationCounselingRevoke = adminUrl + '/admin-fuseTutor/setStatus'
export const kUrlIntegrationCounselingTeacherList = baseUrl + '/base-personInfo/pageListByTeacherQuery'
export const kUrlIntegrationCounselingById = adminUrl + '/admin-fuseTutor/getById'
export const kUrlIntegrationCounselingProcessById = adminUrl + '/admin-fuseTutorContent/getAllList'

//融入辅导 - 流程
export const kUrlCounselingDownCriteria = adminUrl + '/admin-auditCheckStandard/findVersion'
export const kUrlCounselingPostPersonnel = adminUrl + '/admin-mainPersonInfo/list'
export const kUrlCounselingRenewPostPersonnel = adminUrl + '/admin-mainPersonInfo/renew'
export const kUrlCounselingDealerManager = adminUrl + '/admin-dealerManager/list'
export const kUrlCounselingSetDealerManager = adminUrl + '/admin-dealerManager/save'
export const kUrlCounselingStartNotice = adminUrl + '/admin-startNotice/list'
export const kUrlCounselingNoticeDetail = adminUrl + '/admin-startNotice/detailInfo'
export const kUrlCounselingSendNotice = adminUrl + '/admin-startNotice/save'
export const kUrlCounselingConfirmNotice = adminUrl + '/admin-startNotice/confirm'
export const kUrlCounselingUpdateStartNoticeState = adminUrl + '/admin-startNotice/updateStartNoticeState' //修改启动通知状态
export const kUrlCounselingWriteMark = adminUrl + '/admin-mainPersonInfo/writeMark'
export const kUrlCounselingConfirmMainPerson = adminUrl + '/admin-mainPersonInfo/confirm'
export const kUrlCounselingSalesOpening = adminUrl + '/admin-sysOpen/list'
export const kUrlCounselingSalesOpeningDetail = adminUrl + '/admin-sysOpen/auditInfo'
export const kUrlCounselingSalesOpeningAudit = adminUrl + '/admin-sysOpen/audit'
export const kUrlCounselingConfirmSalesOpening = adminUrl + '/admin-sysOpen/confirm'
export const kUrlCounselingCallCar = adminUrl + '/admin-auditCallCar/list'
export const kUrlCounselingCallCarDetail = adminUrl + '/admin-auditCallCar/getById'
export const kUrlCounselingCallCarCheck = adminUrl + '/admin-auditCallCar/check'
export const kUrlCounselingConfirmCallCar = adminUrl + '/admin-auditCallCar/confirm'
export const kUrlCounselingManagerEvaluation = adminUrl + '/admin-managerEvaluation/list'
export const kUrlCounselingManagerEvaluationSave = adminUrl + '/admin-managerEvaluation/save'
export const kUrlCounselingManagerEvaluationDetail = adminUrl + '/admin-managerEvaluation/editInfo'
export const kUrlCounselingConfirmManagerEvaluation = adminUrl + '/admin-managerEvaluation/confirm'
export const kUrlCounselingPreAuditOrCheckInfo = adminUrl + '/admin-auditCheck/findInfo'
export const kUrlCounselingPreAuditOrCheckDetail = adminUrl + '/admin-auditCheck/lookAuditCheckNotice'
export const kUrlCounselingSendPreAuditOrCheck = adminUrl + '/admin-auditCheck/issueAuditCheck'
export const kUrlCounselingConfirmPreAuditOrCheck = adminUrl + '/admin-auditCheck/noticeTargetConfirm'
export const kUrlCounselingUpdateAuditCheckState = adminUrl + '/admin-auditCheck/updateAuditCheckState'
export const kUrlCounselingPreAuditOrCheckAcceptanceResults = adminUrl + '/admin-auditCheckStandard/findEvaluationCriteriaResult'
export const kUrlCounselingPreAuditOrCheckEvaluationCriteria = adminUrl + '/admin-auditCheckStandard/evaluationCriteria'
export const kUrlCounselingUpdateCriteria = adminUrl + '/admin-auditCheckStandard/updateEvaluationCriteria'
export const kUrlCounselingImportCriteria = adminUrl + '/admin-auditCheckStandard/importFile'
export const kUrlCounselingSaveCriteria = adminUrl + '/admin-auditCheckStandard/checkBatchSave'
export const kUrlCounselingRealTimeUpdateCriteria = adminUrl + '/admin-auditCheckStandard/saveEvaluationCriteria'
export const kUrlCounselingCoachProcessList = adminUrl + '/admin-tutorExecute/getTutorExecuteByTutorContentId'
export const kUrlCounselingCoachProcessSend = adminUrl + '/admin-tutorExecute/update'
export const kUrlCounselingConfirmCoachProcess = adminUrl + '/admin-tutorExecute/noticeTargetConfirm'
export const kUrlCounselingGetTrackTrainingMapList = adminUrl + '/admin-trackTraining/getTrackTrainingMapList'
export const kUrlCounselingTrackTrainingNoticeTargetConfirm = adminUrl + '/admin-trackTraining/noticeTargetConfirm'
export const kUrlCounselingTrackTrainingGetApplyPlanPersonInfoList = adminUrl + '/admin-trackTraining/getApplyPlanPersonInfoList'
export const kUrlCounselingTrackTrainingAdd = adminUrl + '/admin-trackTraining/add'
export const kUrlCounselingTrackTrainingUpdate = adminUrl + '/admin-trackTraining/update'
export const kUrlCounselingTrackStableList = adminUrl + '/admin-trackStable/list'
export const kUrlCounselingTrackStableLatestList = adminUrl + '/admin-trackStable/latestList'
export const kUrlCounselingTrackStableNoticeTargetConfirm = adminUrl + '/admin-trackStable/noticeTargetConfirm'
export const kUrlCounselingTrackKpiCycleGetKpiCycleList = adminUrl + '/admin-trackKpiCycle/getKpiCycleList'
export const kUrlCounselingTrackKpiCycleUpdate = adminUrl + '/admin-trackKpiCycle/update'
export const kUrlCounselingTrackKpiCycleNoticeTargetConfirm = adminUrl + '/admin-trackKpiCycle/noticeTargetConfirm'
export const kUrlCounselingTrackSatisfactionEvaluationGetList = adminUrl + '/admin-trackSatisfactionEvaluation/getList'
export const kUrlCounselingTrackSatisfactionEvaluationAdd = adminUrl + '/admin-trackSatisfactionEvaluation/add'
export const kUrlCounselingTrackSatisfactionEvaluationUpdate = adminUrl + '/admin-trackSatisfactionEvaluation/update'
export const kUrlCounselingTrackSatisfactionEvaluationNoticeTargetConfirm= adminUrl + '/admin-trackSatisfactionEvaluation/noticeTargetConfirm'

export const kUrlCounselingTrackCameraList = adminUrl + '/admin-trackCamera/list'
export const kUrlCounselingTrackCameraObtainCameraAssess = adminUrl + '/admin-trackCamera/obtainCameraAssess'
export const kUrlCounselingTrackCameraLookCheckList = adminUrl + '/admin-trackCamera/lookCheckList'
export const kUrlCounselingTrackCameraCheckLookCheckList = adminUrl + '/admin-trackCameraCheck/lookCheckList'
export const kUrlCounselingTrackCameraCheckSaveCommentCheckList = adminUrl + '/admin-trackCameraCheck/saveCommentCheckList'
export const kUrlCounselingTrackCameraNoticeTargetConfirm = adminUrl + '/admin-trackCamera/noticeTargetConfirm'

export const kUrlSyncRelationPositionPageList = adminUrl + '/admin-syncRelation/positionPageList'
export const kUrlSyncRelationPositionList = adminUrl + '/admin-syncRelation/positionList'
export const kUrlSyncRelationSave = adminUrl + '/admin-syncRelation/save'

export const kUrlPositionChangeRecordPageList = adminUrl + '/admin-positionChangeRecord/pageList'
export const kUrlPositionChangeRecordList = adminUrl + '/admin-positionChangeRecord/list'
export const kUrlPositionChangeRecordReExecute = adminUrl + '/admin-positionChangeRecord/syncByPositionChangeRecordId'

export const kUrlChangeRecordDetailPageList = adminUrl + '/admin-positionRecordDetail/pageList'
export const kUrlChangeRecordDetailList = adminUrl + '/admin-positionRecordDetail/list'

export const kUrlSyncEmailConfigPageList = adminUrl + '/admin-syncEmailConfig/pageList'
export const kUrlSyncEmailConfigList = adminUrl + '/admin-syncEmailConfig/list'
export const kUrlSyncEmailConfigSave = adminUrl + '/admin-syncEmailConfig/save'
export const kUrlSyncEmailConfigSetState = adminUrl + '/admin-syncEmailConfig/setState'
export const kUrlVerbalTrickPageList = adminUrl + '/admin-verbalTrick/pageList'
export const kUrlVerbalTrickList = adminUrl + '/admin-verbalTrick/list'
export const kUrlVerbalTrickSave = adminUrl + '/admin-verbalTrick/save'
export const kUrlVerbalTrickEnable = adminUrl + '/admin-verbalTrick/enable'

export const kUrlExamEverydayResultPageList = adminUrl + '/admin-examEverydayResult/pageList'
export const kUrlExamEverydayResultList = adminUrl + '/admin-examEverydayResult/list'
export const kUrlExamEverydayPageList = adminUrl + '/admin-examEverydayResult/examEverydayPageList'
export const kUrlExamEverydayList = adminUrl + '/admin-examEverydayResult/examEverydayList'
export const kUrlExamEverydayRecordList = adminUrl + '/admin-examEverydayResult/examEverydayRecordList'
export const kUrlExamEverydayRecordReport = adminUrl + '/admin-examEverydayResult/examEverydayRecordReport'

export const kUrlFavoritesPageList = adminUrl + '/admin-favorites/pageList'
export const kUrlFavoritesList = adminUrl + '/admin-favorites/list'

export const kUrlNotesPageList = adminUrl + '/admin-notes/pageList'
export const kUrlNotesList = adminUrl + '/admin-notes/list'
export const kUrlNotesRecordPageList = adminUrl + '/admin-notes/recordPageList'
export const kUrlNotesRecordList = adminUrl + '/admin-notes/recordList'

export const kUrlFaceAuthLogPageList = adminUrl + '/admin-faceAuthLog/pageList'//人脸认证详情日志分页
export const kUrlFaceAuthLogList = adminUrl + '/admin-faceAuthLog/list'//人脸认证详情日志集合
export const kUrlFaceAuthLogSelectOne = adminUrl + '/admin-faceAuthLog/getInfo'//单个获取


export const kUrlExamAuthenticationPageList = adminUrl + '/admin-examAuthentication/pageList'//考试认证设置分页
export const kUrlExamAuthenticationList = adminUrl + '/admin-examAuthentication/list'//考试认证设置集合
export const kUrlExamAuthenticationSelectOne = adminUrl + '/admin-examAuthentication/getInfo'//单个获取
export const kUrlExamPersonAuthByExamId = adminUrl + '/admin-examAuthentication/getExamAuthenticationByExamId'//根据考试ID获取

export const kUrlExamPersonAuthPageList = adminUrl + '/admin-examPersonAuth/pageList'//人员考试认证分页
export const kUrlExamPersonAuthList = adminUrl + '/admin-examPersonAuth/list'//人员考试认证集合
export const kUrlExamPersonAuthSelectOne = adminUrl + '/admin-examPersonAuth/getInfo'//单个获取人员考试认证详情
export const kUrlExamPersonAuthInfo = adminUrl + '/admin-examPersonAuth/getExamPersonAuthInfo'//获取认证信息详情 或者下一个待审核
export const kUrlExamPersonAuthAuditResult = adminUrl + '/admin-examPersonAuth/auditResult'//认证审核
export const kUrlExamPersonAuthSave = adminUrl + '/admin-examPersonAuth/examPersonAuthSave' //认证保存
export const kUrlExamPersonAuthByExamPaperId = adminUrl + '/admin-examPersonAuth/getExamPersonAuthByExamPaperId'//获取人员试卷认证信息统计


export const kUrlExamPersonAuthLogPageList = adminUrl + '/admin-examPersonAuthLog/pageList'//人员考试认证明细分页
export const kUrlExamPersonAuthLogList = adminUrl + '/admin-examPersonAuthLog/list'//人员考试认证明细集合
export const kUrlExamPersonAuthLogSelectOne = adminUrl + '/admin-examPersonAuthLog/getInfo'//单个获取人员考试认证明细详情
export const kUrlThirdAppSettingAdd = baseUrl + '/base-appSetting/addAppSetting'
export const kUrlThirdAppSettingUpd = baseUrl + '/base-appSetting/updAppSetting'
export const kUrlThirdAppSettingDel = baseUrl + '/base-appSetting/deleteAppSetting'
export const kUrlThirdAppSettingListByPage = baseUrl + '/base-appSetting/listByPage'
export const kUrlThirdAppSettingList = baseUrl + '/base-appSetting/kUrlThirdAppSettingList'

// 水印管理
export const kUrlWatermarkList = adminUrl + '/admin-watermark/listByPage'
export const kUrlWatermarkAdd = adminUrl + '/admin-watermark/add'
export const kUrlWatermarkUpd = adminUrl + '/admin-watermark/update'
export const kUrlWatermarkEnable = adminUrl + '/admin-watermark/enable'

// 水印
export const kurlWatermarkInfo = adminUrl + '/admin-watermark/list'

//邀请函模版
export const KUrlInviteLetterList = adminUrl + '/admin-inviteLetter/listByPage'
export const KUrlInviteLetterInfo = adminUrl + '/admin-inviteLetter/findByInviteId'
export const KUrlInviteLetterAdd = adminUrl + '/admin-inviteLetter/add'
export const KUrlInviteLetterUpdate = adminUrl + '/admin-inviteLetter/update'
export const KUrlInviteLetterEnable = adminUrl + '/admin-inviteLetter/enable'
//邀请函模版参数
export const KUrlSchemaUserColumnInfo = adminUrl + '/admin-schemaColumns/queryUserColumnInfo'
export const KUrlSchemaColumnsInfo = adminUrl + '/admin-schemaColumns/querySchemaColumnsInfo'

//报名预警
export const kUrlApplyWarningInfo = adminUrl + '/admin-applyWarning/listByApplyId'
export const kUrlApplyWarningAdd = adminUrl + '/admin-applyWarning/add'
export const kUrlApplyWarningUpdate = adminUrl + '/admin-applyWarning/update'

//在线课程学习记录
export const kUrlLearningRecordPageList = adminUrl + '/admin-programResult/learningResultPage'
export const kUrlLearningRecordList = adminUrl + '/admin-programResult/learningResultList'


//管理权限设置
export const kUrlManagerPermissionsSettingPageList = baseUrl + '/base-managerPermissionsSetting/listByPage'
export const kUrlManagerPermissionsSettingAdd = baseUrl + '/base-managerPermissionsSetting/add'
export const kUrlManagerPermissionsSettingUpdate = baseUrl + '/base-managerPermissionsSetting/update'
export const kUrlManagerPermissionsSettingBatchDelete = baseUrl + '/base-managerPermissionsSetting/batchDelete'
export const kUrlManagerPermissionsSettingBatchUpdateSetting = baseUrl + '/base-managerPermissionsSetting/batchUpdateSetting'

//数据迁移设置
export const kUrlSyncTimsTransferPageList = adminUrl + '/admin-syncTimsTransfer/listByPage'
export const kUrlSyncTimsTransferAdd = adminUrl + '/admin-syncTimsTransfer/add'
export const kUrlSyncTimsTransferUpdate = adminUrl + '/admin-syncTimsTransfer/update'
export const kUrSyncTimsTransferDelete = adminUrl + '/admin-syncTimsTransfer/delete'

//修改问题相干
export const kUrlEditPassowrd = baseUrl + '/base-personCenter/updatePassword'//修改密码
export const kUrlSendCode = baseUrl + '/base-captcha/sendMessage'//发送短信、邮件
export const kUrlEditUserInfo = baseUrl + '/base-personCenter/updatePersonInfo'//修改用户信息


export const kUrlPermissionSettingPageList = adminUrl + '/admin-permissionSetting/pageList'
export const kUrlPermissionSettingSave = adminUrl + '/admin-permissionSetting/save'


export const kUrlAccountConsolidationRecordPageList = adminUrl + '/admin-accountConsolidationRecord/pageList'
export const kUrlAccountConsolidationRecordList = adminUrl + '/admin-accountConsolidationRecord/list'
export const kUrlAccountConsolidationRecordById = adminUrl + '/admin-accountConsolidationRecord/getInfoById'
export const kUrlAccountConsolidationRecordAdd = adminUrl + '/admin-accountConsolidationRecord/add'
export const kUrlAccountConsolidationRecordAudit = adminUrl + '/admin-accountConsolidationRecord/audit'

//标签管理
export const kUrlLabelPageList= adminUrl + '/admin-biz-label/listByPage'
export const kUrlLabelList= adminUrl + '/admin-biz-label/list'
export const kUrlLabelAdd= adminUrl + '/admin-biz-label/add'
export const kUrlLabelUpdate= adminUrl + '/admin-biz-label/update'
export const kUrlLabelDelete= adminUrl + '/admin-biz-label/delete'
export const kUrlLabelFeatureContentAdd= adminUrl + '/admin-biz-label/addFeatureContent'
export const kUrlLabelFeatureContent= adminUrl + '/admin-biz-label/labelFeatureContent'
export const kUrlLabelGetById= adminUrl + '/admin-biz-label/getById'
//标签用户
export const kUrlLabelUserPageList= adminUrl + '/admin-labelUser/listByPage'
export const kUrlLabelUserList= adminUrl + '/admin-labelUser/list'
export const kUrlLabelUserAdd= adminUrl + '/admin-labelUser/add'
export const kUrlLabelUserImport= adminUrl + '/admin-labelUser/importFile'

//练习管理
export const kUrlPracticePageList = adminUrl + '/admin-practice/listByPage'
export const kUrlPracticeList = adminUrl + '/admin-practice/export'
export const kUrlPracticeAdd = adminUrl + '/admin-practice/add'
export const kUrlPracticeUpdate = adminUrl + '/admin-practice/update'
export const kUrlPracticeRuleAdd = adminUrl + '/admin-practice/addRule'
export const kUrlPracticeRuleList = adminUrl + '/admin-practice/getRuleInfoById'
export const kUrlPracticeInfoById = adminUrl + '/admin-practice/getBaseInfoById'
export const kUrlPracticeEnable = adminUrl + '/admin-practice/enable'
export const kUrlPracticeDel = adminUrl + '/admin-practice/del'
export const kUrlPracticeFullInfo = adminUrl + '/admin-practice/findById'
//练习排行
export const kUrlPracticeChartsInfo = adminUrl + '/admin-practicePaper/practiceChartsInfo'
export const kUrlPracticeDateChartsInfo = adminUrl + '/admin-practicePaper/practiceDateChartsInfo'
export const kUrlPracticePaperPageList = adminUrl + '/admin-practicePaper/listByPage'
export const kUrlPracticePaperList = adminUrl + '/admin-practicePaper/export'
export const kUrlPracticeDateRankPageList = adminUrl + '/admin-practicePaper/dateByPage'
export const kUrlPracticeDateRankList = adminUrl + '/admin-practicePaper/dateExport'
export const kUrlPracticeRankPageList = adminUrl + '/admin-practicePaper/rankByPage'
export const kUrlPracticeRankList = adminUrl + '/admin-practicePaper/rankExport'
//练习记录
export const kUrlPracticeRecordPageList = adminUrl + '/admin-practicePaper/recordByPage'
export const kUrlPracticeRecordList = adminUrl + '/admin-practicePaper/recordExport'
export const kUrlPracticeDetailPageList = adminUrl + '/admin-practicePaper/detailByPage'
export const kUrlPracticeDetailList = adminUrl + '/admin-practicePaper/detailExport'
export const kUrlPracticePaperDetail = adminUrl + '/admin-practicePaper/getDetailByPaperId'

//课程评价
export const kUrlCommentBatchReviewPre = adminUrl + '/admin-comment/batchReviewPre'
export const kUrlCommentReview = adminUrl + '/admin-comment/reviewComment'
